/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bale
 * This is the API for Bale. At this time, it is not intended for use external to the official
 * Bale apps, and provides no stability or availability guarantees.
 *
 * In addition to everything documented explicitly in the OpenAPI specification, the following
 * considerations apply.
 *
 * ### URL conventions
 *
 * All paths in URLs __must not__ be passed with a trailing slash, if there is a trailing slash in the
 * path, the handler will not be found and the result will be `404 Not Found`.
 *
 * ### Error Responses
 *
 * For application level errors, the response is typically a JSON encoded [`ErrorDetailResponse`](#model/errordetailresponse),
 * and should be documented in the operation responses. For each operation, the list of possible values
 * for the `code` field is fixed, and the corresponding structure of the `details` field is dependent
 * on that code, but this level of detail is not documented at this time.
 *
 * ### Authentication Errors
 *
 * For any request that requires authentication, the `401 Unauthorized` response is also possible.
 * In this situation, the response body is a standard JSON encoded `ErrorDetailResponse`. No
 * `WWW-Authenticate` header is indicated, as we are not using any well known authorization scheme.
 *
 * ### JSON Requests
 *
 * In all operations where the API expects a JSON request body, the following apply:
 *
 * 1. The header `Content-Type: application/json` must be supplied, or the response status will be `415 Unsupported Media Type`
 * 2. The request body must be valid JSON, or the response status will be `400 Bad Request`
 * 3. If the body is valid JSON but does not match the expected type according to the schema, the response status will be `422 Unprocessable Content`
 *
 * These responses will have `Content-Type: text/plain; charset=utf-8` and include only a
 * developer facing message in the body. As these restrictions are applied at the framework
 * level, they do not follow the conventional error details format used for application
 * level errors.
 *
 * Further validation (e.g. value ranges, patterns, lengths, beyond what can be handled by the type system)
 * may be applied by the operation itself, in which case the `422 Unprocessable Content` response is
 * explicitly documented, and an error with the code `ValidationError` may be returned. In this case,
 * the detail field matches the schema [`ValidationError`](#model/validationerror) and can be used
 * to highlight specific issues for the user to address.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  matchQuery,
  queryOptions as queryOptionsBuilder,
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  InvalidateOptions,
  MutationFunction,
  MutationFunctionContext,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";

import {
  AddFriendGroupMemberResponse,
  CreateAccountResponse,
  CreateCalendarResponse,
  CreateEmailAddressResponse,
  CreateEventCommentResponse,
  CreateEventDirectionsResponse,
  CreateEventInviteCodeResponse,
  CreateEventNoteResponse,
  CreateEventPollResponse,
  CreateEventResponse,
  CreateFriendGroupResponse,
  CreateFriendRequestResponse,
  GetAccountResponse,
  GetEmailVerificationRequestResponse,
  GetEventResponse,
  GetFriendGroupResponse,
  ListAccountEmailAddressesResponse,
  ListAccountEventsResponse,
  ListCalendarsResponse,
  ListEventActionLogEntriesResponse,
  ListEventInviteCodesResponse,
  ListEventInvitesResponse,
  ListEventSharesResponse,
  ListEventsResponse,
  ListFriendGroupsResponse,
  ListFriendRequestsResponse,
  ListFriendsResponse,
  ListNotificationsResponse,
  ListSessionsResponse,
  SearchProfilesResponse,
  UpdateAccountResponse,
  UpdateEmailAddressResponse,
  UpdateEventDirectionsResponse,
  UpdateEventInviteResponse,
  UpdateEventNoteResponse,
  UpdateEventParticipationResponse,
  UpdateEventPollResponse,
  UpdateEventPollVotesResponse,
  UpdateEventResponse,
  UpdateEventShareResponse,
  UpdateEventWidgetLayoutResponse,
  UpdateFriendGroupResponse,
  UpdateFriendResponse,
  UpdateNotificationResponse,
  UploadAvatarResponse,
} from "./bale.zod";
import type {
  AccountIdOrMe,
  AddFriendGroupMemberRequest,
  AddFriendGroupMemberResponseOutput,
  CreateAccountAbuseReportRequest,
  CreateAccountRequest,
  CreateAccountResponseOutput,
  CreateCalendarRequest,
  CreateCalendarResponseOutput,
  CreateEmailAddressRequest,
  CreateEmailAddressResponseOutput,
  CreateEventAbuseReportRequest,
  CreateEventCommentRequest,
  CreateEventCommentResponseOutput,
  CreateEventDirectionsRequest,
  CreateEventDirectionsResponseOutput,
  CreateEventInviteCodeResponseOutput,
  CreateEventNoteRequest,
  CreateEventNoteResponseOutput,
  CreateEventPollRequest,
  CreateEventPollResponseOutput,
  CreateEventRequest,
  CreateEventResponseOutput,
  CreateFriendGroupRequest,
  CreateFriendGroupResponseOutput,
  CreateFriendRequestRequest,
  CreateFriendRequestResponseOutput,
  CreatePasswordResetRequestRequest,
  DismissFriendRequestRequest,
  ErrorDetailResponse,
  GetAccountResponseOutput,
  GetEmailVerificationRequestResponseOutput,
  GetEventParams,
  GetEventResponseOutput,
  GetFriendGroupResponseOutput,
  ListAccountEmailAddressesResponseOutput,
  ListAccountEventsParams,
  ListAccountEventsResponseOutput,
  ListCalendarsResponseOutput,
  ListEventActionLogEntriesParams,
  ListEventActionLogEntriesResponseOutput,
  ListEventInviteCodesResponseOutput,
  ListEventInvitesResponseOutput,
  ListEventSharesResponseOutput,
  ListEventsParams,
  ListEventsResponseOutput,
  ListFriendGroupsResponseOutput,
  ListFriendRequestsResponseOutput,
  ListFriendsResponseOutput,
  ListNotificationsParams,
  ListNotificationsResponseOutput,
  ListSessionsResponseOutput,
  LoginRequest,
  RemoveFriendGroupMemberRequest,
  ResetPasswordRequest,
  SearchProfilesParams,
  SearchProfilesResponseOutput,
  SubscribeNotificationsRequest,
  UpdateAccountRequest,
  UpdateAccountResponseOutput,
  UpdateEmailAddressRequest,
  UpdateEmailAddressResponseOutput,
  UpdateEventDirectionsRequest,
  UpdateEventDirectionsResponseOutput,
  UpdateEventInviteRequest,
  UpdateEventInviteResponseOutput,
  UpdateEventNoteRequest,
  UpdateEventNoteResponseOutput,
  UpdateEventParticipationRequest,
  UpdateEventParticipationResponseOutput,
  UpdateEventPollRequest,
  UpdateEventPollResponseOutput,
  UpdateEventPollVotesRequest,
  UpdateEventPollVotesResponseOutput,
  UpdateEventRequest,
  UpdateEventResponseOutput,
  UpdateEventShareRequest,
  UpdateEventShareResponseOutput,
  UpdateEventWidgetLayoutRequest,
  UpdateEventWidgetLayoutResponseOutput,
  UpdateFriendGroupRequest,
  UpdateFriendGroupResponseOutput,
  UpdateFriendRequest,
  UpdateFriendResponseOutput,
  UpdateNotificationRequest,
  UpdateNotificationResponseOutput,
  UpdatePasswordRequest,
  UploadAvatarRequest,
  UploadAvatarResponseOutput,
  ViewCalendarParams,
} from "./bale.zod";

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type healthResponse204 = {
  data: void;
  status: 204;
};

export type healthResponseSuccess = healthResponse204 & {
  headers: Headers;
};

export const getHealthUrl = () => {
  return `/api/health`;
};

/**
 * Check service status.
 * @summary Health
 */
export const health = async (options?: RequestInit): Promise<healthResponseSuccess> => {
  const res = await fetch(getHealthUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: healthResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as healthResponseSuccess;
};

export const getHealthQueryKey = () => {
  return [`/api/health`] as const;
};

export const getHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof health>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof health>>> = ({ signal }) =>
    health({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof health>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthQueryResult = NonNullable<Awaited<ReturnType<typeof health>>>;
export type HealthQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useHealth<
  TData = Awaited<ReturnType<typeof health>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof health>>,
          TError,
          Awaited<ReturnType<typeof health>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealth<
  TData = Awaited<ReturnType<typeof health>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof health>>,
          TError,
          Awaited<ReturnType<typeof health>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealth<
  TData = Awaited<ReturnType<typeof health>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Health
 */

export function useHealth<
  TData = Awaited<ReturnType<typeof health>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHealthQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useHealth} query
 */
export const invalidateHealth = async (
  queryClient: QueryClient,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getHealthQueryKey() }, options);

  return queryClient;
};

export const getHealthSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof health>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof health>>> = ({ signal }) =>
    health({ signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type HealthSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof health>>>;
export type HealthSuspenseQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useHealthSuspense<
  TData = Awaited<ReturnType<typeof health>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthSuspense<
  TData = Awaited<ReturnType<typeof health>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthSuspense<
  TData = Awaited<ReturnType<typeof health>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Health
 */

export function useHealthSuspense<
  TData = Awaited<ReturnType<typeof health>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHealthSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateAccountResponse200 = {
  data: UpdateAccountResponseOutput;
  status: 200;
};

export type updateAccountResponse403 = {
  data: ErrorDetailResponse;
  status: 403;
};

export type updateAccountResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateAccountResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateAccountResponseSuccess = updateAccountResponse200 & {
  headers: Headers;
};
export type updateAccountResponseError = (
  | updateAccountResponse403
  | updateAccountResponse404
  | updateAccountResponse422
) & {
  headers: Headers;
};

export const getUpdateAccountUrl = () => {
  return `/api/v1/accounts`;
};

/**
 * Update account and profile information.
 * @summary Update Account
 */
export const updateAccount = async (
  updateAccountRequest: UpdateAccountRequest,
  options?: RequestInit,
): Promise<updateAccountResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateAccountUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAccountRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: updateAccountResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: updateAccountResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeUpdateAccountResponse(parsedBody as UpdateAccountResponse);
  }
  const data = contentType.includes("json") ? UpdateAccountResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateAccountResponseSuccess;
};

const deserializeUpdateAccountResponse = (data: UpdateAccountResponse): UpdateAccountResponse => {
  if (data == null) return data;
  if (data.profile != null) {
    data.profile.created_at = new Date(data.profile.created_at);
  }
  return data;
};

export const getUpdateAccountMutationKey = () => ["updateAccount"] as const;

export const getUpdateAccountMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAccount>>,
      TError,
      UpdateAccountMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof updateAccount>>,
  TError,
  UpdateAccountMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateAccountMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAccount>>,
    UpdateAccountMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateAccount(data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof updateAccount>>,
    variables: UpdateAccountMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.resetQueries({ queryKey: getGetProfileQueryKey("@me") });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type UpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccount>>>;
export type UpdateAccountMutationBody = UpdateAccountRequest;
export type UpdateAccountMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateAccountMutationVariables = { data: UpdateAccountRequest };

/**
 * @summary Update Account
 */
export const useUpdateAccount = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAccount>>,
      TError,
      UpdateAccountMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAccount>>,
  TError,
  UpdateAccountMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getUpdateAccountMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type createAccountResponse200 = {
  data: CreateAccountResponseOutput;
  status: 200;
};

export type createAccountResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createAccountResponseSuccess = createAccountResponse200 & {
  headers: Headers;
};
export type createAccountResponseError = createAccountResponse422 & {
  headers: Headers;
};

export const getCreateAccountUrl = () => {
  return `/api/v1/accounts`;
};

/**
 * Sign up for a new account.
 * @summary Create Account/Sign Up
 */
export const createAccount = async (
  createAccountRequest: CreateAccountRequest,
  options?: RequestInit,
): Promise<createAccountResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateAccountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createAccountRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: createAccountResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: createAccountResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json") ? CreateAccountResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as createAccountResponseSuccess;
};

export const getCreateAccountMutationKey = () => ["createAccount"] as const;

export const getCreateAccountMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccount>>,
    TError,
    CreateAccountMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccount>>,
  TError,
  CreateAccountMutationVariables,
  TContext
> => {
  const mutationKey = getCreateAccountMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccount>>,
    CreateAccountMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createAccount(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createAccount>>>;
export type CreateAccountMutationBody = CreateAccountRequest;
export type CreateAccountMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateAccountMutationVariables = { data: CreateAccountRequest };

/**
 * @summary Create Account/Sign Up
 */
export const useCreateAccount = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAccount>>,
      TError,
      CreateAccountMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAccount>>,
  TError,
  CreateAccountMutationVariables,
  TContext
> => {
  return useMutation(getCreateAccountMutationOptions(options), queryClient);
};

export type deleteAccountResponse204 = {
  data: void;
  status: 204;
};

export type deleteAccountResponseSuccess = deleteAccountResponse204 & {
  headers: Headers;
};

export const getDeleteAccountUrl = () => {
  return `/api/v1/accounts`;
};

/**
 * Deletes the currently authenticated account. This will delete EVERYTHING related to
 * this account, immediately and permanently.
 * @summary Delete Account
 */
export const deleteAccount = async (
  options?: RequestInit,
): Promise<deleteAccountResponseSuccess> => {
  const res = await fetch(getDeleteAccountUrl(), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteAccountResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as deleteAccountResponseSuccess;
};

export const getDeleteAccountMutationKey = () => ["deleteAccount"] as const;

export const getDeleteAccountMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError, void, TContext>;
  fetch?: RequestInit;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError, void, TContext> => {
  const mutationKey = getDeleteAccountMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, void> = () => {
    return deleteAccount(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>;

export type DeleteAccountMutationError = globalThis.Error & { info?: unknown; status?: number };

/**
 * @summary Delete Account
 */
export const useDeleteAccount = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAccount>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof deleteAccount>>, TError, void, TContext> => {
  return useMutation(getDeleteAccountMutationOptions(options), queryClient);
};

export type listAccountEmailAddressesResponse200 = {
  data: ListAccountEmailAddressesResponseOutput;
  status: 200;
};

export type listAccountEmailAddressesResponseSuccess = listAccountEmailAddressesResponse200 & {
  headers: Headers;
};

export const getListAccountEmailAddressesUrl = (accountId: AccountIdOrMe) => {
  return `/api/v1/accounts/${accountId}/email-addresses`;
};

/**
 * Lists email addresses associated with an account. Currently you can only view your own account's email addresses.
 * @summary List Account Email Addresses
 */
export const listAccountEmailAddresses = async (
  accountId: AccountIdOrMe,
  options?: RequestInit,
): Promise<listAccountEmailAddressesResponseSuccess> => {
  const res = await fetch(getListAccountEmailAddressesUrl(accountId), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? ListAccountEmailAddressesResponse.parse(parsedBody)
    : parsedBody;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as listAccountEmailAddressesResponseSuccess;
};

export const getListAccountEmailAddressesQueryKey = (accountId: AccountIdOrMe) => {
  return [`/api/v1/accounts/${accountId}/email-addresses`] as const;
};

export const getListAccountEmailAddressesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountEmailAddresses>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountEmailAddressesQueryKey(accountId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountEmailAddresses>>> = ({
    signal,
  }) => listAccountEmailAddresses(accountId, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: accountId !== null && accountId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListAccountEmailAddressesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountEmailAddresses>>
>;
export type ListAccountEmailAddressesQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListAccountEmailAddresses<
  TData = Awaited<ReturnType<typeof listAccountEmailAddresses>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountEmailAddresses>>,
          TError,
          Awaited<ReturnType<typeof listAccountEmailAddresses>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEmailAddresses<
  TData = Awaited<ReturnType<typeof listAccountEmailAddresses>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountEmailAddresses>>,
          TError,
          Awaited<ReturnType<typeof listAccountEmailAddresses>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEmailAddresses<
  TData = Awaited<ReturnType<typeof listAccountEmailAddresses>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Account Email Addresses
 */

export function useListAccountEmailAddresses<
  TData = Awaited<ReturnType<typeof listAccountEmailAddresses>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAccountEmailAddressesQueryOptions(accountId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListAccountEmailAddresses} query
 */
export const invalidateListAccountEmailAddresses = async (
  queryClient: QueryClient,
  accountId: AccountIdOrMe,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getListAccountEmailAddressesQueryKey(accountId) },
    options,
  );

  return queryClient;
};

export const getListAccountEmailAddressesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountEmailAddresses>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountEmailAddressesQueryKey(accountId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountEmailAddresses>>> = ({
    signal,
  }) => listAccountEmailAddresses(accountId, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listAccountEmailAddresses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListAccountEmailAddressesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountEmailAddresses>>
>;
export type ListAccountEmailAddressesSuspenseQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListAccountEmailAddressesSuspense<
  TData = Awaited<ReturnType<typeof listAccountEmailAddresses>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEmailAddressesSuspense<
  TData = Awaited<ReturnType<typeof listAccountEmailAddresses>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEmailAddressesSuspense<
  TData = Awaited<ReturnType<typeof listAccountEmailAddresses>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Account Email Addresses
 */

export function useListAccountEmailAddressesSuspense<
  TData = Awaited<ReturnType<typeof listAccountEmailAddresses>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEmailAddresses>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAccountEmailAddressesSuspenseQueryOptions(accountId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listAccountEventsResponse200 = {
  data: ListAccountEventsResponseOutput;
  status: 200;
};

export type listAccountEventsResponseSuccess = listAccountEventsResponse200 & {
  headers: Headers;
};

export const getListAccountEventsUrl = (
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["event_status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/accounts/${accountId}/events?${stringifiedParams}`
    : `/api/v1/accounts/${accountId}/events`;
};

/**
 * List events hosted by a particular user, which are visible to the authenticated account.
 * See [List Events](#tag/events/GET/api/v1/accounts/foxfriends/events) for more details on the conditions for
 * visibility. Note that the "not_ready" event status allows seeing events that otherwise
 * are missing required details for the regular List Events API.
 *
 * This is a paginated API. Responses are returned in order of `start_time`.
 * @summary List Hosted Events
 */
export const listAccountEvents = async (
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: RequestInit,
): Promise<listAccountEventsResponseSuccess> => {
  const res = await fetch(getListAccountEventsUrl(accountId, params), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeListAccountEventsResponse(parsedBody as ListAccountEventsResponse);
  }
  const data = contentType.includes("json")
    ? ListAccountEventsResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as listAccountEventsResponseSuccess;
};

const deserializeListAccountEventsResponse = (
  data: ListAccountEventsResponse,
): ListAccountEventsResponse => {
  if (data == null) return data;
  if (data.events != null) {
    for (let i0 = 0; i0 < data.events.length; i0++) {
      const item0 = data.events[i0]!;
      if (item0.event != null) {
        if (item0.event.end_time != null) {
          item0.event.end_time = new Date(item0.event.end_time);
        }
        if (item0.event.start_time != null) {
          item0.event.start_time = new Date(item0.event.start_time);
        }
      }
    }
  }
  return data;
};

export const getListAccountEventsInfiniteQueryKey = (
  accountId: AccountIdOrMe,
  params?: ListAccountEventsParams,
) => {
  return ["infinite", `/api/v1/accounts/${accountId}/events`, ...(params ? [params] : [])] as const;
};

export const getListAccountEventsQueryKey = (
  accountId: AccountIdOrMe,
  params?: ListAccountEventsParams,
) => {
  return [`/api/v1/accounts/${accountId}/events`, ...(params ? [params] : [])] as const;
};

export const getListAccountEventsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAccountEvents>>,
    ListAccountEventsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAccountEvents>>,
        TError,
        TData,
        QueryKey,
        ListAccountEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAccountEventsInfiniteQueryKey(accountId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountEvents>>,
    QueryKey,
    ListAccountEventsParams["after_cursor"]
  > = ({ signal, pageParam }) =>
    listAccountEvents(
      accountId,
      { ...params, after_cursor: pageParam ?? params?.["after_cursor"] },
      { signal, ...fetchOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: accountId !== null && accountId !== undefined,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAccountEvents>>,
    TError,
    TData,
    QueryKey,
    ListAccountEventsParams["after_cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAccountEventsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountEvents>>
>;
export type ListAccountEventsInfiniteQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListAccountEventsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAccountEvents>>,
    ListAccountEventsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAccountEvents>>,
        TError,
        TData,
        QueryKey,
        ListAccountEventsParams["after_cursor"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountEvents>>,
          TError,
          Awaited<ReturnType<typeof listAccountEvents>>,
          QueryKey
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEventsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAccountEvents>>,
    ListAccountEventsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAccountEvents>>,
        TError,
        TData,
        QueryKey,
        ListAccountEventsParams["after_cursor"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountEvents>>,
          TError,
          Awaited<ReturnType<typeof listAccountEvents>>,
          QueryKey
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEventsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAccountEvents>>,
    ListAccountEventsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAccountEvents>>,
        TError,
        TData,
        QueryKey,
        ListAccountEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Hosted Events
 */

export function useListAccountEventsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAccountEvents>>,
    ListAccountEventsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAccountEvents>>,
        TError,
        TData,
        QueryKey,
        ListAccountEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAccountEventsInfiniteQueryOptions(accountId, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListAccountEventsInfinite} query
 */
export const invalidateListAccountEventsInfinite = async (
  queryClient: QueryClient,
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getListAccountEventsInfiniteQueryKey(accountId, params) },
    options,
  );

  return queryClient;
};

export const getListAccountEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountEventsQueryKey(accountId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountEvents>>> = ({ signal }) =>
    listAccountEvents(accountId, params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: accountId !== null && accountId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListAccountEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountEvents>>
>;
export type ListAccountEventsQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListAccountEvents<
  TData = Awaited<ReturnType<typeof listAccountEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountEvents>>,
          TError,
          Awaited<ReturnType<typeof listAccountEvents>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEvents<
  TData = Awaited<ReturnType<typeof listAccountEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountEvents>>,
          TError,
          Awaited<ReturnType<typeof listAccountEvents>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEvents<
  TData = Awaited<ReturnType<typeof listAccountEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Hosted Events
 */

export function useListAccountEvents<
  TData = Awaited<ReturnType<typeof listAccountEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAccountEventsQueryOptions(accountId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListAccountEvents} query
 */
export const invalidateListAccountEvents = async (
  queryClient: QueryClient,
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getListAccountEventsQueryKey(accountId, params) },
    options,
  );

  return queryClient;
};

export const getListAccountEventsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountEventsQueryKey(accountId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountEvents>>> = ({ signal }) =>
    listAccountEvents(accountId, params, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListAccountEventsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountEvents>>
>;
export type ListAccountEventsSuspenseQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListAccountEventsSuspense<
  TData = Awaited<ReturnType<typeof listAccountEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEventsSuspense<
  TData = Awaited<ReturnType<typeof listAccountEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEventsSuspense<
  TData = Awaited<ReturnType<typeof listAccountEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Hosted Events
 */

export function useListAccountEventsSuspense<
  TData = Awaited<ReturnType<typeof listAccountEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountEvents>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAccountEventsSuspenseQueryOptions(accountId, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListAccountEventsSuspenseInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAccountEvents>>,
    ListAccountEventsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAccountEvents>>,
        TError,
        TData,
        QueryKey,
        ListAccountEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAccountEventsInfiniteQueryKey(accountId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountEvents>>,
    QueryKey,
    ListAccountEventsParams["after_cursor"]
  > = ({ signal, pageParam }) =>
    listAccountEvents(
      accountId,
      { ...params, after_cursor: pageParam ?? params?.["after_cursor"] },
      { signal, ...fetchOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAccountEvents>>,
    TError,
    TData,
    QueryKey,
    ListAccountEventsParams["after_cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAccountEventsSuspenseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountEvents>>
>;
export type ListAccountEventsSuspenseInfiniteQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListAccountEventsSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAccountEvents>>,
    ListAccountEventsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options: {
    query: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAccountEvents>>,
        TError,
        TData,
        QueryKey,
        ListAccountEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEventsSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAccountEvents>>,
    ListAccountEventsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAccountEvents>>,
        TError,
        TData,
        QueryKey,
        ListAccountEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountEventsSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAccountEvents>>,
    ListAccountEventsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAccountEvents>>,
        TError,
        TData,
        QueryKey,
        ListAccountEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Hosted Events
 */

export function useListAccountEventsSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAccountEvents>>,
    ListAccountEventsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  params: ListAccountEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAccountEvents>>,
        TError,
        TData,
        QueryKey,
        ListAccountEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAccountEventsSuspenseInfiniteQueryOptions(accountId, params, options);

  const query = useSuspenseInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listFriendsResponse200 = {
  data: ListFriendsResponseOutput;
  status: 200;
};

export type listFriendsResponseSuccess = listFriendsResponse200 & {
  headers: Headers;
};

export const getListFriendsUrl = (accountId: AccountIdOrMe) => {
  return `/api/v1/accounts/${accountId}/friends`;
};

/**
 * List all friends.
 * @summary List Friends
 */
export const listFriends = async (
  accountId: AccountIdOrMe,
  options?: RequestInit,
): Promise<listFriendsResponseSuccess> => {
  const res = await fetch(getListFriendsUrl(accountId), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeListFriendsResponse(parsedBody as ListFriendsResponse);
  }
  const data = contentType.includes("json") ? ListFriendsResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as listFriendsResponseSuccess;
};

const deserializeListFriendsResponse = (data: ListFriendsResponse): ListFriendsResponse => {
  if (data == null) return data;
  if (data.friends != null) {
    for (let i0 = 0; i0 < data.friends.length; i0++) {
      const item0 = data.friends[i0]!;
      item0.created_at = new Date(item0.created_at);
      if (item0.profile != null) {
        item0.profile.created_at = new Date(item0.profile.created_at);
      }
      if (item0.verified_at != null) {
        item0.verified_at = new Date(item0.verified_at);
      }
    }
  }
  return data;
};

export const getListFriendsQueryKey = (accountId: AccountIdOrMe) => {
  return [`/api/v1/accounts/${accountId}/friends`] as const;
};

export const getListFriendsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFriends>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFriendsQueryKey(accountId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFriends>>> = ({ signal }) =>
    listFriends(accountId, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: accountId !== null && accountId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListFriendsQueryResult = NonNullable<Awaited<ReturnType<typeof listFriends>>>;
export type ListFriendsQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListFriends<
  TData = Awaited<ReturnType<typeof listFriends>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFriends>>,
          TError,
          Awaited<ReturnType<typeof listFriends>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriends<
  TData = Awaited<ReturnType<typeof listFriends>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFriends>>,
          TError,
          Awaited<ReturnType<typeof listFriends>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriends<
  TData = Awaited<ReturnType<typeof listFriends>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Friends
 */

export function useListFriends<
  TData = Awaited<ReturnType<typeof listFriends>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListFriendsQueryOptions(accountId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListFriends} query
 */
export const invalidateListFriends = async (
  queryClient: QueryClient,
  accountId: AccountIdOrMe,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListFriendsQueryKey(accountId) }, options);

  return queryClient;
};

export const getListFriendsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listFriends>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFriendsQueryKey(accountId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFriends>>> = ({ signal }) =>
    listFriends(accountId, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListFriendsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listFriends>>>;
export type ListFriendsSuspenseQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListFriendsSuspense<
  TData = Awaited<ReturnType<typeof listFriends>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriendsSuspense<
  TData = Awaited<ReturnType<typeof listFriends>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriendsSuspense<
  TData = Awaited<ReturnType<typeof listFriends>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Friends
 */

export function useListFriendsSuspense<
  TData = Awaited<ReturnType<typeof listFriends>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriends>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListFriendsSuspenseQueryOptions(accountId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createAccountAbuseReportResponse201 = {
  data: void;
  status: 201;
};

export type createAccountAbuseReportResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type createAccountAbuseReportResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createAccountAbuseReportResponseSuccess = createAccountAbuseReportResponse201 & {
  headers: Headers;
};
export type createAccountAbuseReportResponseError = (
  | createAccountAbuseReportResponse404
  | createAccountAbuseReportResponse422
) & {
  headers: Headers;
};

export const getCreateAccountAbuseReportUrl = (accountId: string) => {
  return `/api/v1/accounts/${accountId}/report`;
};

/**
 * Report an account for abuse.
 * @summary Report Account
 */
export const createAccountAbuseReport = async (
  accountId: string,
  createAccountAbuseReportRequest: CreateAccountAbuseReportRequest,
  options?: RequestInit,
): Promise<createAccountAbuseReportResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateAccountAbuseReportUrl(accountId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createAccountAbuseReportRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: createAccountAbuseReportResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: createAccountAbuseReportResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: createAccountAbuseReportResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createAccountAbuseReportResponseSuccess;
};

export const getCreateAccountAbuseReportMutationKey = () => ["createAccountAbuseReport"] as const;

export const getCreateAccountAbuseReportMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountAbuseReport>>,
    TError,
    CreateAccountAbuseReportMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccountAbuseReport>>,
  TError,
  CreateAccountAbuseReportMutationVariables,
  TContext
> => {
  const mutationKey = getCreateAccountAbuseReportMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccountAbuseReport>>,
    CreateAccountAbuseReportMutationVariables
  > = (props) => {
    const { accountId, data } = props ?? {};

    return createAccountAbuseReport(accountId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccountAbuseReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccountAbuseReport>>
>;
export type CreateAccountAbuseReportMutationBody = CreateAccountAbuseReportRequest;
export type CreateAccountAbuseReportMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateAccountAbuseReportMutationVariables = {
  accountId: string;
  data: CreateAccountAbuseReportRequest;
};

/**
 * @summary Report Account
 */
export const useCreateAccountAbuseReport = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAccountAbuseReport>>,
      TError,
      CreateAccountAbuseReportMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAccountAbuseReport>>,
  TError,
  CreateAccountAbuseReportMutationVariables,
  TContext
> => {
  return useMutation(getCreateAccountAbuseReportMutationOptions(options), queryClient);
};

export type loginResponse204 = {
  data: void;
  status: 204;
};

export type loginResponse403 = {
  data: ErrorDetailResponse;
  status: 403;
};

export type loginResponseSuccess = loginResponse204 & {
  headers: Headers;
};
export type loginResponseError = loginResponse403 & {
  headers: Headers;
};

export const getLoginUrl = () => {
  return `/api/v1/auth`;
};

/**
 * Login using username/password. This will set the session cookie for use in other requests.
 * Clear this cookie by calling [Logout](#tag/accounts/POST/api/v1/auth/logout).
 * @summary Login
 */
export const login = async (
  loginRequest: LoginRequest,
  options?: RequestInit,
): Promise<loginResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(loginRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: loginResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: loginResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: loginResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as loginResponseSuccess;
};

export const getLoginMutationKey = () => ["login"] as const;

export const getLoginMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof login>>,
      TError,
      LoginMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  LoginMutationVariables,
  TContext
> => {
  const mutationKey = getLoginMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, LoginMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return login(data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof login>>,
    variables: LoginMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.resetQueries({ queryKey: getGetProfileQueryKey("@me") });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>;
export type LoginMutationBody = LoginRequest;
export type LoginMutationError = globalThis.Error & { info?: ErrorDetailResponse; status?: number };
export type LoginMutationVariables = { data: LoginRequest };

/**
 * @summary Login
 */
export const useLogin = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof login>>,
      TError,
      LoginMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  LoginMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getLoginMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type logoutResponse204 = {
  data: void;
  status: 204;
};

export type logoutResponseSuccess = logoutResponse204 & {
  headers: Headers;
};

export const getLogoutUrl = () => {
  return `/api/v1/auth/logout`;
};

/**
 * Removes the authorization information from session cookie. The cookie may still be set
 * but it no longer provides access.
 * @summary Logout
 */
export const logout = async (options?: RequestInit): Promise<logoutResponseSuccess> => {
  const res = await fetch(getLogoutUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: logoutResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as logoutResponseSuccess;
};

export const getLogoutMutationKey = () => ["logout"] as const;

export const getLogoutMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError, void, TContext>;
  fetch?: RequestInit;
}): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError, void, TContext> => {
  const mutationKey = getLogoutMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {
    return logout(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>;

export type LogoutMutationError = globalThis.Error & { info?: unknown; status?: number };

/**
 * @summary Logout
 */
export const useLogout = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError, void, TContext>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof logout>>, TError, void, TContext> => {
  return useMutation(getLogoutMutationOptions(options), queryClient);
};

export type uploadAvatarResponse201 = {
  data: UploadAvatarResponseOutput;
  status: 201;
};

export type uploadAvatarResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type uploadAvatarResponseSuccess = uploadAvatarResponse201 & {
  headers: Headers;
};
export type uploadAvatarResponseError = uploadAvatarResponse422 & {
  headers: Headers;
};

export const getUploadAvatarUrl = () => {
  return `/api/v1/avatars`;
};

/**
 * Register an image upload for later use as an avatar. The full process to set the avatar is:
 * 1. Call `upload_avatar` (this route) with the details of the image.
 * 2. `PUT` the image data at the returned `upload_url`.
 * 3. Use [`update_account`](#tag/accounts/PUT/api/v1/accounts) to set the avatar image ID once image upload is complete.
 * @summary Upload Avatar
 */
export const uploadAvatar = async (
  uploadAvatarRequest: UploadAvatarRequest,
  options?: RequestInit,
): Promise<uploadAvatarResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUploadAvatarUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadAvatarRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: uploadAvatarResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: uploadAvatarResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json") ? UploadAvatarResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as uploadAvatarResponseSuccess;
};

export const getUploadAvatarMutationKey = () => ["uploadAvatar"] as const;

export const getUploadAvatarMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadAvatar>>,
    TError,
    UploadAvatarMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadAvatar>>,
  TError,
  UploadAvatarMutationVariables,
  TContext
> => {
  const mutationKey = getUploadAvatarMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadAvatar>>,
    UploadAvatarMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return uploadAvatar(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAvatar>>>;
export type UploadAvatarMutationBody = UploadAvatarRequest;
export type UploadAvatarMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UploadAvatarMutationVariables = { data: UploadAvatarRequest };

/**
 * @summary Upload Avatar
 */
export const useUploadAvatar = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadAvatar>>,
      TError,
      UploadAvatarMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadAvatar>>,
  TError,
  UploadAvatarMutationVariables,
  TContext
> => {
  return useMutation(getUploadAvatarMutationOptions(options), queryClient);
};

export type listCalendarsResponse200 = {
  data: ListCalendarsResponseOutput;
  status: 200;
};

export type listCalendarsResponseSuccess = listCalendarsResponse200 & {
  headers: Headers;
};

export const getListCalendarsUrl = () => {
  return `/api/v1/calendars`;
};

/**
 * List calendars created by this account.
 * @summary List Calendars
 */
export const listCalendars = async (
  options?: RequestInit,
): Promise<listCalendarsResponseSuccess> => {
  const res = await fetch(getListCalendarsUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json") ? ListCalendarsResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as listCalendarsResponseSuccess;
};

export const getListCalendarsQueryKey = () => {
  return [`/api/v1/calendars`] as const;
};

export const getListCalendarsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCalendars>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>>;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCalendarsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendars>>> = ({ signal }) =>
    listCalendars({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCalendars>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCalendarsQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendars>>>;
export type ListCalendarsQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListCalendars<
  TData = Awaited<ReturnType<typeof listCalendars>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCalendars>>,
          TError,
          Awaited<ReturnType<typeof listCalendars>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCalendars<
  TData = Awaited<ReturnType<typeof listCalendars>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCalendars>>,
          TError,
          Awaited<ReturnType<typeof listCalendars>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCalendars<
  TData = Awaited<ReturnType<typeof listCalendars>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Calendars
 */

export function useListCalendars<
  TData = Awaited<ReturnType<typeof listCalendars>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListCalendarsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListCalendars} query
 */
export const invalidateListCalendars = async (
  queryClient: QueryClient,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListCalendarsQueryKey() }, options);

  return queryClient;
};

export const getListCalendarsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listCalendars>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCalendarsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendars>>> = ({ signal }) =>
    listCalendars({ signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListCalendarsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCalendars>>
>;
export type ListCalendarsSuspenseQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListCalendarsSuspense<
  TData = Awaited<ReturnType<typeof listCalendars>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCalendarsSuspense<
  TData = Awaited<ReturnType<typeof listCalendars>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCalendarsSuspense<
  TData = Awaited<ReturnType<typeof listCalendars>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Calendars
 */

export function useListCalendarsSuspense<
  TData = Awaited<ReturnType<typeof listCalendars>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListCalendarsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createCalendarResponse200 = {
  data: CreateCalendarResponseOutput;
  status: 200;
};

export type createCalendarResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createCalendarResponseSuccess = createCalendarResponse200 & {
  headers: Headers;
};
export type createCalendarResponseError = createCalendarResponse422 & {
  headers: Headers;
};

export const getCreateCalendarUrl = () => {
  return `/api/v1/calendars`;
};

/**
 * Exposes a publicly visible iCalendar, allowing access to your events. Note that any user with
 * the resulting calendar URL has visibility into the events on that calendar, so the URL must be
 * treated sensitively by users.
 *
 * The created calendar URL will remain valid indefinitely, unless explicitly deleted.
 * @summary Create Calendar
 */
export const createCalendar = async (
  createCalendarRequest: CreateCalendarRequest,
  options?: RequestInit,
): Promise<createCalendarResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateCalendarUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createCalendarRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: createCalendarResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: createCalendarResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json") ? CreateCalendarResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as createCalendarResponseSuccess;
};

export const getCreateCalendarMutationKey = () => ["createCalendar"] as const;

export const getCreateCalendarMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCalendar>>,
      TError,
      CreateCalendarMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof createCalendar>>,
  TError,
  CreateCalendarMutationVariables,
  TContext
> => {
  const mutationKey = getCreateCalendarMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCalendar>>,
    CreateCalendarMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createCalendar(data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof createCalendar>>,
    variables: CreateCalendarMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListCalendarsQueryKey() });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type CreateCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof createCalendar>>>;
export type CreateCalendarMutationBody = CreateCalendarRequest;
export type CreateCalendarMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateCalendarMutationVariables = { data: CreateCalendarRequest };

/**
 * @summary Create Calendar
 */
export const useCreateCalendar = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCalendar>>,
      TError,
      CreateCalendarMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCalendar>>,
  TError,
  CreateCalendarMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getCreateCalendarMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type deleteCalendarResponse204 = {
  data: void;
  status: 204;
};

export type deleteCalendarResponseSuccess = deleteCalendarResponse204 & {
  headers: Headers;
};

export const getDeleteCalendarUrl = (calendarId: string) => {
  return `/api/v1/calendars/${calendarId}`;
};

/**
 * Deletes a previously created calendar. The URL associated with this calendar will cease to work,
 * users should be reminded to remove the imported calendar from their linked calendar applications.
 * @summary Delete Calendar
 */
export const deleteCalendar = async (
  calendarId: string,
  options?: RequestInit,
): Promise<deleteCalendarResponseSuccess> => {
  const res = await fetch(getDeleteCalendarUrl(calendarId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteCalendarResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as deleteCalendarResponseSuccess;
};

export const getDeleteCalendarMutationKey = () => ["deleteCalendar"] as const;

export const getDeleteCalendarMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCalendar>>,
      TError,
      DeleteCalendarMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCalendar>>,
  TError,
  DeleteCalendarMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteCalendarMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCalendar>>,
    DeleteCalendarMutationVariables
  > = (props) => {
    const { calendarId } = props ?? {};

    return deleteCalendar(calendarId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof deleteCalendar>>,
    variables: DeleteCalendarMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListCalendarsQueryKey() });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type DeleteCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCalendar>>>;

export type DeleteCalendarMutationError = globalThis.Error & { info?: unknown; status?: number };
export type DeleteCalendarMutationVariables = { calendarId: string };

/**
 * @summary Delete Calendar
 */
export const useDeleteCalendar = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCalendar>>,
      TError,
      DeleteCalendarMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCalendar>>,
  TError,
  DeleteCalendarMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getDeleteCalendarMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type viewCalendarResponse404 = {
  data: void;
  status: 404;
};
export type viewCalendarResponseError = viewCalendarResponse404 & {
  headers: Headers;
};

export type viewCalendarResponse = viewCalendarResponseError;

export const getViewCalendarUrl = (calendarId: string, params: ViewCalendarParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/calendars/${calendarId}/events.ics?${stringifiedParams}`
    : `/api/v1/calendars/${calendarId}/events.ics`;
};

/**
 * Retrieves an iCalendar file computed based on the events the account that created this calendar
 * is attending or has visible. Note that once a calendar is created, it is public to any who have
 * its ID, so care should be taken not to expose calendar URLs unintentionally.
 * @summary View Calendar
 */
export const viewCalendar = async (
  calendarId: string,
  params: ViewCalendarParams,
  options?: RequestInit,
): Promise<viewCalendarResponse> => {
  const res = await fetch(getViewCalendarUrl(calendarId, params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: viewCalendarResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: viewCalendarResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: viewCalendarResponse["data"] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as viewCalendarResponse;
};

export const getViewCalendarQueryKey = (calendarId: string, params?: ViewCalendarParams) => {
  return [`/api/v1/calendars/${calendarId}/events.ics`, ...(params ? [params] : [])] as const;
};

export const getViewCalendarQueryOptions = <
  TData = Awaited<ReturnType<typeof viewCalendar>>,
  TError = globalThis.Error & { info?: void; status?: number },
>(
  calendarId: string,
  params: ViewCalendarParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getViewCalendarQueryKey(calendarId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof viewCalendar>>> = ({ signal }) =>
    viewCalendar(calendarId, params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: calendarId !== null && calendarId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ViewCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof viewCalendar>>>;
export type ViewCalendarQueryError = globalThis.Error & { info?: void; status?: number };

export function useViewCalendar<
  TData = Awaited<ReturnType<typeof viewCalendar>>,
  TError = globalThis.Error & { info?: void; status?: number },
>(
  calendarId: string,
  params: ViewCalendarParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewCalendar>>,
          TError,
          Awaited<ReturnType<typeof viewCalendar>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useViewCalendar<
  TData = Awaited<ReturnType<typeof viewCalendar>>,
  TError = globalThis.Error & { info?: void; status?: number },
>(
  calendarId: string,
  params: ViewCalendarParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewCalendar>>,
          TError,
          Awaited<ReturnType<typeof viewCalendar>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useViewCalendar<
  TData = Awaited<ReturnType<typeof viewCalendar>>,
  TError = globalThis.Error & { info?: void; status?: number },
>(
  calendarId: string,
  params: ViewCalendarParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary View Calendar
 */

export function useViewCalendar<
  TData = Awaited<ReturnType<typeof viewCalendar>>,
  TError = globalThis.Error & { info?: void; status?: number },
>(
  calendarId: string,
  params: ViewCalendarParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getViewCalendarQueryOptions(calendarId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useViewCalendar} query
 */
export const invalidateViewCalendar = async (
  queryClient: QueryClient,
  calendarId: string,
  params: ViewCalendarParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getViewCalendarQueryKey(calendarId, params) },
    options,
  );

  return queryClient;
};

export const getViewCalendarSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof viewCalendar>>,
  TError = globalThis.Error & { info?: void; status?: number },
>(
  calendarId: string,
  params: ViewCalendarParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getViewCalendarQueryKey(calendarId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof viewCalendar>>> = ({ signal }) =>
    viewCalendar(calendarId, params, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ViewCalendarSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof viewCalendar>>>;
export type ViewCalendarSuspenseQueryError = globalThis.Error & { info?: void; status?: number };

export function useViewCalendarSuspense<
  TData = Awaited<ReturnType<typeof viewCalendar>>,
  TError = globalThis.Error & { info?: void; status?: number },
>(
  calendarId: string,
  params: ViewCalendarParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useViewCalendarSuspense<
  TData = Awaited<ReturnType<typeof viewCalendar>>,
  TError = globalThis.Error & { info?: void; status?: number },
>(
  calendarId: string,
  params: ViewCalendarParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useViewCalendarSuspense<
  TData = Awaited<ReturnType<typeof viewCalendar>>,
  TError = globalThis.Error & { info?: void; status?: number },
>(
  calendarId: string,
  params: ViewCalendarParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary View Calendar
 */

export function useViewCalendarSuspense<
  TData = Awaited<ReturnType<typeof viewCalendar>>,
  TError = globalThis.Error & { info?: void; status?: number },
>(
  calendarId: string,
  params: ViewCalendarParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof viewCalendar>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getViewCalendarSuspenseQueryOptions(calendarId, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createEmailAddressResponse200 = {
  data: CreateEmailAddressResponseOutput;
  status: 200;
};

export type createEmailAddressResponse409 = {
  data: ErrorDetailResponse;
  status: 409;
};

export type createEmailAddressResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createEmailAddressResponseSuccess = createEmailAddressResponse200 & {
  headers: Headers;
};
export type createEmailAddressResponseError = (
  | createEmailAddressResponse409
  | createEmailAddressResponse422
) & {
  headers: Headers;
};

export const getCreateEmailAddressUrl = () => {
  return `/api/v1/email-addresses`;
};

/**
 * Adds a new email address to the account. The address must be verified before it can
 * be set as primary or used to receive notifications.
 * @summary Create Email Address
 */
export const createEmailAddress = async (
  createEmailAddressRequest: CreateEmailAddressRequest,
  options?: RequestInit,
): Promise<createEmailAddressResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateEmailAddressUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createEmailAddressRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: createEmailAddressResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: createEmailAddressResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? CreateEmailAddressResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as createEmailAddressResponseSuccess;
};

export const getCreateEmailAddressMutationKey = () => ["createEmailAddress"] as const;

export const getCreateEmailAddressMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEmailAddress>>,
      TError,
      CreateEmailAddressMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof createEmailAddress>>,
  TError,
  CreateEmailAddressMutationVariables,
  TContext
> => {
  const mutationKey = getCreateEmailAddressMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEmailAddress>>,
    CreateEmailAddressMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createEmailAddress(data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof createEmailAddress>>,
    variables: CreateEmailAddressMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" &&
          query.queryKey[0].startsWith("/api/v1/accounts/"),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type CreateEmailAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEmailAddress>>
>;
export type CreateEmailAddressMutationBody = CreateEmailAddressRequest;
export type CreateEmailAddressMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateEmailAddressMutationVariables = { data: CreateEmailAddressRequest };

/**
 * @summary Create Email Address
 */
export const useCreateEmailAddress = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEmailAddress>>,
      TError,
      CreateEmailAddressMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEmailAddress>>,
  TError,
  CreateEmailAddressMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getCreateEmailAddressMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type updateEmailAddressResponse200 = {
  data: UpdateEmailAddressResponseOutput;
  status: 200;
};

export type updateEmailAddressResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateEmailAddressResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateEmailAddressResponseSuccess = updateEmailAddressResponse200 & {
  headers: Headers;
};
export type updateEmailAddressResponseError = (
  | updateEmailAddressResponse404
  | updateEmailAddressResponse422
) & {
  headers: Headers;
};

export const getUpdateEmailAddressUrl = (emailId: number) => {
  return `/api/v1/email-addresses/${emailId}`;
};

/**
 * Updates properties of the email address.
 * @summary Update Email Address
 */
export const updateEmailAddress = async (
  emailId: number,
  updateEmailAddressRequest: UpdateEmailAddressRequest,
  options?: RequestInit,
): Promise<updateEmailAddressResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateEmailAddressUrl(emailId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEmailAddressRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: updateEmailAddressResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: updateEmailAddressResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? UpdateEmailAddressResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateEmailAddressResponseSuccess;
};

export const getUpdateEmailAddressMutationKey = () => ["updateEmailAddress"] as const;

export const getUpdateEmailAddressMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmailAddress>>,
      TError,
      UpdateEmailAddressMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailAddress>>,
  TError,
  UpdateEmailAddressMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateEmailAddressMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailAddress>>,
    UpdateEmailAddressMutationVariables
  > = (props) => {
    const { emailId, data } = props ?? {};

    return updateEmailAddress(emailId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof updateEmailAddress>>,
    variables: UpdateEmailAddressMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" &&
          query.queryKey[0].startsWith("/api/v1/accounts/"),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type UpdateEmailAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailAddress>>
>;
export type UpdateEmailAddressMutationBody = UpdateEmailAddressRequest;
export type UpdateEmailAddressMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateEmailAddressMutationVariables = {
  emailId: number;
  data: UpdateEmailAddressRequest;
};

/**
 * @summary Update Email Address
 */
export const useUpdateEmailAddress = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmailAddress>>,
      TError,
      UpdateEmailAddressMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailAddress>>,
  TError,
  UpdateEmailAddressMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getUpdateEmailAddressMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type deleteEmailAddressResponse204 = {
  data: void;
  status: 204;
};

export type deleteEmailAddressResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type deleteEmailAddressResponseSuccess = deleteEmailAddressResponse204 & {
  headers: Headers;
};
export type deleteEmailAddressResponseError = deleteEmailAddressResponse422 & {
  headers: Headers;
};

export const getDeleteEmailAddressUrl = (emailId: number) => {
  return `/api/v1/email-addresses/${emailId}`;
};

/**
 * Deletes an email address from the account. The primary email address may not be deleted.
 * @summary Delete Email Address
 */
export const deleteEmailAddress = async (
  emailId: number,
  options?: RequestInit,
): Promise<deleteEmailAddressResponseSuccess> => {
  const res = await fetch(getDeleteEmailAddressUrl(emailId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: deleteEmailAddressResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: deleteEmailAddressResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteEmailAddressResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as deleteEmailAddressResponseSuccess;
};

export const getDeleteEmailAddressMutationKey = () => ["deleteEmailAddress"] as const;

export const getDeleteEmailAddressMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEmailAddress>>,
      TError,
      DeleteEmailAddressMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEmailAddress>>,
  TError,
  DeleteEmailAddressMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteEmailAddressMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEmailAddress>>,
    DeleteEmailAddressMutationVariables
  > = (props) => {
    const { emailId } = props ?? {};

    return deleteEmailAddress(emailId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof deleteEmailAddress>>,
    variables: DeleteEmailAddressMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" &&
          query.queryKey[0].startsWith("/api/v1/accounts/"),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type DeleteEmailAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEmailAddress>>
>;

export type DeleteEmailAddressMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type DeleteEmailAddressMutationVariables = { emailId: number };

/**
 * @summary Delete Email Address
 */
export const useDeleteEmailAddress = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEmailAddress>>,
      TError,
      DeleteEmailAddressMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEmailAddress>>,
  TError,
  DeleteEmailAddressMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getDeleteEmailAddressMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type createEmailVerificationRequestResponse204 = {
  data: void;
  status: 204;
};

export type createEmailVerificationRequestResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type createEmailVerificationRequestResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createEmailVerificationRequestResponse429 = {
  data: ErrorDetailResponse;
  status: 429;
};

export type createEmailVerificationRequestResponseSuccess =
  createEmailVerificationRequestResponse204 & {
    headers: Headers;
  };
export type createEmailVerificationRequestResponseError = (
  | createEmailVerificationRequestResponse404
  | createEmailVerificationRequestResponse422
  | createEmailVerificationRequestResponse429
) & {
  headers: Headers;
};

export const getCreateEmailVerificationRequestUrl = (emailId: number) => {
  return `/api/v1/email-addresses/${emailId}/verification`;
};

/**
 * Resends an email verification request to an unverified email address.
 *
 * Only 3 active verification requests may exist for one account; further submissions
 * will not go through until some start to expire.
 * @summary Create Email Address Verification Request
 */
export const createEmailVerificationRequest = async (
  emailId: number,
  options?: RequestInit,
): Promise<createEmailVerificationRequestResponseSuccess> => {
  const res = await fetch(getCreateEmailVerificationRequestUrl(emailId), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: createEmailVerificationRequestResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: createEmailVerificationRequestResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: createEmailVerificationRequestResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createEmailVerificationRequestResponseSuccess;
};

export const getCreateEmailVerificationRequestMutationKey = () =>
  ["createEmailVerificationRequest"] as const;

export const getCreateEmailVerificationRequestMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEmailVerificationRequest>>,
    TError,
    CreateEmailVerificationRequestMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEmailVerificationRequest>>,
  TError,
  CreateEmailVerificationRequestMutationVariables,
  TContext
> => {
  const mutationKey = getCreateEmailVerificationRequestMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEmailVerificationRequest>>,
    CreateEmailVerificationRequestMutationVariables
  > = (props) => {
    const { emailId } = props ?? {};

    return createEmailVerificationRequest(emailId, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEmailVerificationRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEmailVerificationRequest>>
>;

export type CreateEmailVerificationRequestMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateEmailVerificationRequestMutationVariables = { emailId: number };

/**
 * @summary Create Email Address Verification Request
 */
export const useCreateEmailVerificationRequest = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEmailVerificationRequest>>,
      TError,
      CreateEmailVerificationRequestMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEmailVerificationRequest>>,
  TError,
  CreateEmailVerificationRequestMutationVariables,
  TContext
> => {
  return useMutation(getCreateEmailVerificationRequestMutationOptions(options), queryClient);
};

export type getEmailVerificationRequestResponse200 = {
  data: GetEmailVerificationRequestResponseOutput;
  status: 200;
};

export type getEmailVerificationRequestResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type getEmailVerificationRequestResponseSuccess = getEmailVerificationRequestResponse200 & {
  headers: Headers;
};
export type getEmailVerificationRequestResponseError = getEmailVerificationRequestResponse404 & {
  headers: Headers;
};

export const getGetEmailVerificationRequestUrl = (verificationId: string) => {
  return `/api/v1/email-verifications/${verificationId}`;
};

/**
 * Gets the details of this email verification request.
 * @summary Get Email Address Verification Request
 */
export const getEmailVerificationRequest = async (
  verificationId: string,
  options?: RequestInit,
): Promise<getEmailVerificationRequestResponseSuccess> => {
  const res = await fetch(getGetEmailVerificationRequestUrl(verificationId), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: getEmailVerificationRequestResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getEmailVerificationRequestResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeGetEmailVerificationRequestResponse(
      parsedBody as GetEmailVerificationRequestResponse,
    );
  }
  const data = contentType.includes("json")
    ? GetEmailVerificationRequestResponse.parse(parsedBody)
    : parsedBody;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getEmailVerificationRequestResponseSuccess;
};

const deserializeGetEmailVerificationRequestResponse = (
  data: GetEmailVerificationRequestResponse,
): GetEmailVerificationRequestResponse => {
  if (data == null) return data;
  if (data.email_verification != null) {
    data.email_verification.expires_at = new Date(data.email_verification.expires_at);
  }
  return data;
};

export const getGetEmailVerificationRequestQueryKey = (verificationId: string) => {
  return [`/api/v1/email-verifications/${verificationId}`] as const;
};

export const getGetEmailVerificationRequestQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailVerificationRequest>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  verificationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailVerificationRequest>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailVerificationRequestQueryKey(verificationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailVerificationRequest>>> = ({
    signal,
  }) => getEmailVerificationRequest(verificationId, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: verificationId !== null && verificationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEmailVerificationRequest>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetEmailVerificationRequestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailVerificationRequest>>
>;
export type GetEmailVerificationRequestQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useGetEmailVerificationRequest<
  TData = Awaited<ReturnType<typeof getEmailVerificationRequest>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  verificationId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailVerificationRequest>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailVerificationRequest>>,
          TError,
          Awaited<ReturnType<typeof getEmailVerificationRequest>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmailVerificationRequest<
  TData = Awaited<ReturnType<typeof getEmailVerificationRequest>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  verificationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailVerificationRequest>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailVerificationRequest>>,
          TError,
          Awaited<ReturnType<typeof getEmailVerificationRequest>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmailVerificationRequest<
  TData = Awaited<ReturnType<typeof getEmailVerificationRequest>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  verificationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailVerificationRequest>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Email Address Verification Request
 */

export function useGetEmailVerificationRequest<
  TData = Awaited<ReturnType<typeof getEmailVerificationRequest>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  verificationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailVerificationRequest>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmailVerificationRequestQueryOptions(verificationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useGetEmailVerificationRequest} query
 */
export const invalidateGetEmailVerificationRequest = async (
  queryClient: QueryClient,
  verificationId: string,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getGetEmailVerificationRequestQueryKey(verificationId) },
    options,
  );

  return queryClient;
};

export const getGetEmailVerificationRequestSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailVerificationRequest>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  verificationId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getEmailVerificationRequest>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailVerificationRequestQueryKey(verificationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailVerificationRequest>>> = ({
    signal,
  }) => getEmailVerificationRequest(verificationId, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getEmailVerificationRequest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type GetEmailVerificationRequestSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailVerificationRequest>>
>;
export type GetEmailVerificationRequestSuspenseQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useGetEmailVerificationRequestSuspense<
  TData = Awaited<ReturnType<typeof getEmailVerificationRequest>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  verificationId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getEmailVerificationRequest>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmailVerificationRequestSuspense<
  TData = Awaited<ReturnType<typeof getEmailVerificationRequest>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  verificationId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getEmailVerificationRequest>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmailVerificationRequestSuspense<
  TData = Awaited<ReturnType<typeof getEmailVerificationRequest>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  verificationId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getEmailVerificationRequest>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Email Address Verification Request
 */

export function useGetEmailVerificationRequestSuspense<
  TData = Awaited<ReturnType<typeof getEmailVerificationRequest>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  verificationId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getEmailVerificationRequest>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmailVerificationRequestSuspenseQueryOptions(verificationId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type verifyEmailAddressResponse204 = {
  data: void;
  status: 204;
};

export type verifyEmailAddressResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type verifyEmailAddressResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type verifyEmailAddressResponseSuccess = verifyEmailAddressResponse204 & {
  headers: Headers;
};
export type verifyEmailAddressResponseError = (
  | verifyEmailAddressResponse404
  | verifyEmailAddressResponse422
) & {
  headers: Headers;
};

export const getVerifyEmailAddressUrl = (verificationId: string) => {
  return `/api/v1/email-verifications/${verificationId}/verify`;
};

/**
 * Marks an email as verified.
 * @summary Verify Email Address
 */
export const verifyEmailAddress = async (
  verificationId: string,
  options?: RequestInit,
): Promise<verifyEmailAddressResponseSuccess> => {
  const res = await fetch(getVerifyEmailAddressUrl(verificationId), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: verifyEmailAddressResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: verifyEmailAddressResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: verifyEmailAddressResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as verifyEmailAddressResponseSuccess;
};

export const getVerifyEmailAddressMutationKey = () => ["verifyEmailAddress"] as const;

export const getVerifyEmailAddressMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmailAddress>>,
    TError,
    VerifyEmailAddressMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyEmailAddress>>,
  TError,
  VerifyEmailAddressMutationVariables,
  TContext
> => {
  const mutationKey = getVerifyEmailAddressMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyEmailAddress>>,
    VerifyEmailAddressMutationVariables
  > = (props) => {
    const { verificationId } = props ?? {};

    return verifyEmailAddress(verificationId, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyEmailAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyEmailAddress>>
>;

export type VerifyEmailAddressMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type VerifyEmailAddressMutationVariables = { verificationId: string };

/**
 * @summary Verify Email Address
 */
export const useVerifyEmailAddress = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyEmailAddress>>,
      TError,
      VerifyEmailAddressMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyEmailAddress>>,
  TError,
  VerifyEmailAddressMutationVariables,
  TContext
> => {
  return useMutation(getVerifyEmailAddressMutationOptions(options), queryClient);
};

export type updateEventDirectionsResponse200 = {
  data: UpdateEventDirectionsResponseOutput;
  status: 200;
};

export type updateEventDirectionsResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateEventDirectionsResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateEventDirectionsResponseSuccess = updateEventDirectionsResponse200 & {
  headers: Headers;
};
export type updateEventDirectionsResponseError = (
  | updateEventDirectionsResponse404
  | updateEventDirectionsResponse422
) & {
  headers: Headers;
};

export const getUpdateEventDirectionsUrl = (widgetId: string) => {
  return `/api/v1/event-directions/${widgetId}`;
};

/**
 * Update map pin and arrival instructions for an event. You can only update events that you created.
 * @summary Update Event Directions
 */
export const updateEventDirections = async (
  widgetId: string,
  updateEventDirectionsRequest: UpdateEventDirectionsRequest,
  options?: RequestInit,
): Promise<updateEventDirectionsResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateEventDirectionsUrl(widgetId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEventDirectionsRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: updateEventDirectionsResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: updateEventDirectionsResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? UpdateEventDirectionsResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateEventDirectionsResponseSuccess;
};

export const getUpdateEventDirectionsMutationKey = () => ["updateEventDirections"] as const;

export const getUpdateEventDirectionsMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEventDirections>>,
    TError,
    UpdateEventDirectionsMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEventDirections>>,
  TError,
  UpdateEventDirectionsMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateEventDirectionsMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEventDirections>>,
    UpdateEventDirectionsMutationVariables
  > = (props) => {
    const { widgetId, data } = props ?? {};

    return updateEventDirections(widgetId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEventDirectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEventDirections>>
>;
export type UpdateEventDirectionsMutationBody = UpdateEventDirectionsRequest;
export type UpdateEventDirectionsMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateEventDirectionsMutationVariables = {
  widgetId: string;
  data: UpdateEventDirectionsRequest;
};

/**
 * @summary Update Event Directions
 */
export const useUpdateEventDirections = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventDirections>>,
      TError,
      UpdateEventDirectionsMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEventDirections>>,
  TError,
  UpdateEventDirectionsMutationVariables,
  TContext
> => {
  return useMutation(getUpdateEventDirectionsMutationOptions(options), queryClient);
};

export type updateEventNoteResponse200 = {
  data: UpdateEventNoteResponseOutput;
  status: 200;
};

export type updateEventNoteResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateEventNoteResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateEventNoteResponseSuccess = updateEventNoteResponse200 & {
  headers: Headers;
};
export type updateEventNoteResponseError = (
  | updateEventNoteResponse404
  | updateEventNoteResponse422
) & {
  headers: Headers;
};

export const getUpdateEventNoteUrl = (widgetId: string) => {
  return `/api/v1/event-notes/${widgetId}`;
};

/**
 * Update note widget. You can only update events that you created.
 * @summary Update Event Note
 */
export const updateEventNote = async (
  widgetId: string,
  updateEventNoteRequest: UpdateEventNoteRequest,
  options?: RequestInit,
): Promise<updateEventNoteResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateEventNoteUrl(widgetId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEventNoteRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: updateEventNoteResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: updateEventNoteResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? UpdateEventNoteResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateEventNoteResponseSuccess;
};

export const getUpdateEventNoteMutationKey = () => ["updateEventNote"] as const;

export const getUpdateEventNoteMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEventNote>>,
    TError,
    UpdateEventNoteMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEventNote>>,
  TError,
  UpdateEventNoteMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateEventNoteMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEventNote>>,
    UpdateEventNoteMutationVariables
  > = (props) => {
    const { widgetId, data } = props ?? {};

    return updateEventNote(widgetId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEventNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEventNote>>
>;
export type UpdateEventNoteMutationBody = UpdateEventNoteRequest;
export type UpdateEventNoteMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateEventNoteMutationVariables = { widgetId: string; data: UpdateEventNoteRequest };

/**
 * @summary Update Event Note
 */
export const useUpdateEventNote = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventNote>>,
      TError,
      UpdateEventNoteMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEventNote>>,
  TError,
  UpdateEventNoteMutationVariables,
  TContext
> => {
  return useMutation(getUpdateEventNoteMutationOptions(options), queryClient);
};

export type updateEventPollResponse200 = {
  data: UpdateEventPollResponseOutput;
  status: 200;
};

export type updateEventPollResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateEventPollResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateEventPollResponseSuccess = updateEventPollResponse200 & {
  headers: Headers;
};
export type updateEventPollResponseError = (
  | updateEventPollResponse404
  | updateEventPollResponse422
) & {
  headers: Headers;
};

export const getUpdateEventPollUrl = (widgetId: string) => {
  return `/api/v1/event-polls/${widgetId}`;
};

/**
 * Update a poll for an event. You can only update widgets for events that you created.
 * @summary Update Event Poll
 */
export const updateEventPoll = async (
  widgetId: string,
  updateEventPollRequest: UpdateEventPollRequest,
  options?: RequestInit,
): Promise<updateEventPollResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateEventPollUrl(widgetId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEventPollRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: updateEventPollResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: updateEventPollResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? UpdateEventPollResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateEventPollResponseSuccess;
};

export const getUpdateEventPollMutationKey = () => ["updateEventPoll"] as const;

export const getUpdateEventPollMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEventPoll>>,
    TError,
    UpdateEventPollMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEventPoll>>,
  TError,
  UpdateEventPollMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateEventPollMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEventPoll>>,
    UpdateEventPollMutationVariables
  > = (props) => {
    const { widgetId, data } = props ?? {};

    return updateEventPoll(widgetId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEventPollMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEventPoll>>
>;
export type UpdateEventPollMutationBody = UpdateEventPollRequest;
export type UpdateEventPollMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateEventPollMutationVariables = { widgetId: string; data: UpdateEventPollRequest };

/**
 * @summary Update Event Poll
 */
export const useUpdateEventPoll = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventPoll>>,
      TError,
      UpdateEventPollMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEventPoll>>,
  TError,
  UpdateEventPollMutationVariables,
  TContext
> => {
  return useMutation(getUpdateEventPollMutationOptions(options), queryClient);
};

export type updateEventPollVotesResponse200 = {
  data: UpdateEventPollVotesResponseOutput;
  status: 200;
};

export type updateEventPollVotesResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateEventPollVotesResponse409 = {
  data: ErrorDetailResponse;
  status: 409;
};

export type updateEventPollVotesResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateEventPollVotesResponseSuccess = updateEventPollVotesResponse200 & {
  headers: Headers;
};
export type updateEventPollVotesResponseError = (
  | updateEventPollVotesResponse404
  | updateEventPollVotesResponse409
  | updateEventPollVotesResponse422
) & {
  headers: Headers;
};

export const getUpdateEventPollVotesUrl = (widgetId: string) => {
  return `/api/v1/event-polls/${widgetId}/votes`;
};

/**
 * Vote on a poll.
 * @summary Update Event Poll Votes
 */
export const updateEventPollVotes = async (
  widgetId: string,
  updateEventPollVotesRequest: UpdateEventPollVotesRequest,
  options?: RequestInit,
): Promise<updateEventPollVotesResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateEventPollVotesUrl(widgetId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEventPollVotesRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: updateEventPollVotesResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: updateEventPollVotesResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? UpdateEventPollVotesResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateEventPollVotesResponseSuccess;
};

export const getUpdateEventPollVotesMutationKey = () => ["updateEventPollVotes"] as const;

export const getUpdateEventPollVotesMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEventPollVotes>>,
    TError,
    UpdateEventPollVotesMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEventPollVotes>>,
  TError,
  UpdateEventPollVotesMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateEventPollVotesMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEventPollVotes>>,
    UpdateEventPollVotesMutationVariables
  > = (props) => {
    const { widgetId, data } = props ?? {};

    return updateEventPollVotes(widgetId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEventPollVotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEventPollVotes>>
>;
export type UpdateEventPollVotesMutationBody = UpdateEventPollVotesRequest;
export type UpdateEventPollVotesMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateEventPollVotesMutationVariables = {
  widgetId: string;
  data: UpdateEventPollVotesRequest;
};

/**
 * @summary Update Event Poll Votes
 */
export const useUpdateEventPollVotes = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventPollVotes>>,
      TError,
      UpdateEventPollVotesMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEventPollVotes>>,
  TError,
  UpdateEventPollVotesMutationVariables,
  TContext
> => {
  return useMutation(getUpdateEventPollVotesMutationOptions(options), queryClient);
};

export type deleteEventWidgetResponse204 = {
  data: void;
  status: 204;
};

export type deleteEventWidgetResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type deleteEventWidgetResponse422 = {
  data: void;
  status: 422;
};

export type deleteEventWidgetResponseSuccess = deleteEventWidgetResponse204 & {
  headers: Headers;
};
export type deleteEventWidgetResponseError = (
  | deleteEventWidgetResponse404
  | deleteEventWidgetResponse422
) & {
  headers: Headers;
};

export const getDeleteEventWidgetUrl = (widgetId: string) => {
  return `/api/v1/event-widgets/${widgetId}`;
};

/**
 * Remove a widget and its joined data from an event. Host only. Idempotent when the widget is
 * already absent. The required default widgets cannot be removed.
 * @summary Delete Event Widget
 */
export const deleteEventWidget = async (
  widgetId: string,
  options?: RequestInit,
): Promise<deleteEventWidgetResponseSuccess> => {
  const res = await fetch(getDeleteEventWidgetUrl(widgetId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: deleteEventWidgetResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: deleteEventWidgetResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteEventWidgetResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as deleteEventWidgetResponseSuccess;
};

export const getDeleteEventWidgetMutationKey = () => ["deleteEventWidget"] as const;

export const getDeleteEventWidgetMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse | void; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEventWidget>>,
    TError,
    DeleteEventWidgetMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEventWidget>>,
  TError,
  DeleteEventWidgetMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteEventWidgetMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEventWidget>>,
    DeleteEventWidgetMutationVariables
  > = (props) => {
    const { widgetId } = props ?? {};

    return deleteEventWidget(widgetId, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEventWidgetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEventWidget>>
>;

export type DeleteEventWidgetMutationError = globalThis.Error & {
  info?: ErrorDetailResponse | void;
  status?: number;
};
export type DeleteEventWidgetMutationVariables = { widgetId: string };

/**
 * @summary Delete Event Widget
 */
export const useDeleteEventWidget = <
  TError = globalThis.Error & { info?: ErrorDetailResponse | void; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEventWidget>>,
      TError,
      DeleteEventWidgetMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEventWidget>>,
  TError,
  DeleteEventWidgetMutationVariables,
  TContext
> => {
  return useMutation(getDeleteEventWidgetMutationOptions(options), queryClient);
};

export type listEventsResponse200 = {
  data: ListEventsResponseOutput;
  status: 200;
};

export type listEventsResponseSuccess = listEventsResponse200 & {
  headers: Headers;
};

export const getListEventsUrl = (params?: ListEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(
        key,
        value === null ? "null" : value instanceof Date ? value.toISOString() : String(value),
      );
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/events?${stringifiedParams}` : `/api/v1/events`;
};

/**
 * List events visible to the authenticated account. Events are visible when their event details are sufficiently filled,
 * and at least one of the following conditions applies:
 * * You created the event.
 * * You are attending the event.
 * * You are directly invited to the event by another attendee.
 * * The event is shared to you as a member of an attendee's friend group.
 * * The event is discoverable by you as a friend of an attendee who has made the event visible to all friends.
 *
 * This is a paginated API. Responses are returned in order of `start_time`.
 * @summary List Events
 */
export const listEvents = async (
  params?: ListEventsParams,
  options?: RequestInit,
): Promise<listEventsResponseSuccess> => {
  const res = await fetch(getListEventsUrl(params), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeListEventsResponse(parsedBody as ListEventsResponse);
  }
  const data = contentType.includes("json") ? ListEventsResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as listEventsResponseSuccess;
};

const deserializeListEventsResponse = (data: ListEventsResponse): ListEventsResponse => {
  if (data == null) return data;
  if (data.events != null) {
    for (let i0 = 0; i0 < data.events.length; i0++) {
      const item0 = data.events[i0]!;
      if (item0.event != null) {
        if (item0.event.end_time != null) {
          item0.event.end_time = new Date(item0.event.end_time);
        }
        if (item0.event.start_time != null) {
          item0.event.start_time = new Date(item0.event.start_time);
        }
      }
      if (item0.host != null) {
        item0.host.created_at = new Date(item0.host.created_at);
      }
    }
  }
  return data;
};

export const getListEventsInfiniteQueryKey = (params?: ListEventsParams) => {
  return ["infinite", `/api/v1/events`, ...(params ? [params] : [])] as const;
};

export const getListEventsQueryKey = (params?: ListEventsParams) => {
  return [`/api/v1/events`, ...(params ? [params] : [])] as const;
};

export const getListEventsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof listEvents>>, ListEventsParams["after_cursor"]>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEvents>>,
        TError,
        TData,
        QueryKey,
        ListEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEvents>>,
    QueryKey,
    ListEventsParams["after_cursor"]
  > = ({ signal, pageParam }) =>
    listEvents(
      { ...params, after_cursor: pageParam ?? params?.["after_cursor"] },
      { signal, ...fetchOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listEvents>>,
    TError,
    TData,
    QueryKey,
    ListEventsParams["after_cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEventsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listEvents>>>;
export type ListEventsInfiniteQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListEventsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof listEvents>>, ListEventsParams["after_cursor"]>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: undefined | ListEventsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEvents>>,
        TError,
        TData,
        QueryKey,
        ListEventsParams["after_cursor"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvents>>,
          TError,
          Awaited<ReturnType<typeof listEvents>>,
          QueryKey
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof listEvents>>, ListEventsParams["after_cursor"]>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEvents>>,
        TError,
        TData,
        QueryKey,
        ListEventsParams["after_cursor"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvents>>,
          TError,
          Awaited<ReturnType<typeof listEvents>>,
          QueryKey
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof listEvents>>, ListEventsParams["after_cursor"]>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEvents>>,
        TError,
        TData,
        QueryKey,
        ListEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Events
 */

export function useListEventsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof listEvents>>, ListEventsParams["after_cursor"]>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEvents>>,
        TError,
        TData,
        QueryKey,
        ListEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListEventsInfinite} query
 */
export const invalidateListEventsInfinite = async (
  queryClient: QueryClient,
  params?: ListEventsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListEventsInfiniteQueryKey(params) }, options);

  return queryClient;
};

export const getListEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvents>>> = ({ signal }) =>
    listEvents(params, { signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listEvents>>>;
export type ListEventsQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: undefined | ListEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvents>>,
          TError,
          Awaited<ReturnType<typeof listEvents>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvents>>,
          TError,
          Awaited<ReturnType<typeof listEvents>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Events
 */

export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListEvents} query
 */
export const invalidateListEvents = async (
  queryClient: QueryClient,
  params?: ListEventsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListEventsQueryKey(params) }, options);

  return queryClient;
};

export const getListEventsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvents>>> = ({ signal }) =>
    listEvents(params, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListEventsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listEvents>>>;
export type ListEventsSuspenseQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListEventsSuspense<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: undefined | ListEventsParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventsSuspense<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventsSuspense<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Events
 */

export function useListEventsSuspense<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListEventsSuspenseInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof listEvents>>, ListEventsParams["after_cursor"]>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEvents>>,
        TError,
        TData,
        QueryKey,
        ListEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEvents>>,
    QueryKey,
    ListEventsParams["after_cursor"]
  > = ({ signal, pageParam }) =>
    listEvents(
      { ...params, after_cursor: pageParam ?? params?.["after_cursor"] },
      { signal, ...fetchOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listEvents>>,
    TError,
    TData,
    QueryKey,
    ListEventsParams["after_cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEventsSuspenseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEvents>>
>;
export type ListEventsSuspenseInfiniteQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListEventsSuspenseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof listEvents>>, ListEventsParams["after_cursor"]>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: undefined | ListEventsParams,
  options: {
    query: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEvents>>,
        TError,
        TData,
        QueryKey,
        ListEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventsSuspenseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof listEvents>>, ListEventsParams["after_cursor"]>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEvents>>,
        TError,
        TData,
        QueryKey,
        ListEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventsSuspenseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof listEvents>>, ListEventsParams["after_cursor"]>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEvents>>,
        TError,
        TData,
        QueryKey,
        ListEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Events
 */

export function useListEventsSuspenseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof listEvents>>, ListEventsParams["after_cursor"]>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEvents>>,
        TError,
        TData,
        QueryKey,
        ListEventsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventsSuspenseInfiniteQueryOptions(params, options);

  const query = useSuspenseInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createEventResponse200 = {
  data: CreateEventResponseOutput;
  status: 200;
};

export type createEventResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createEventResponseSuccess = createEventResponse200 & {
  headers: Headers;
};
export type createEventResponseError = createEventResponse422 & {
  headers: Headers;
};

export const getCreateEventUrl = () => {
  return `/api/v1/events`;
};

/**
 * Create a new event.
 * @summary Create Event
 */
export const createEvent = async (
  createEventRequest: CreateEventRequest,
  options?: RequestInit,
): Promise<createEventResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateEventUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createEventRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: createEventResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: createEventResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeCreateEventResponse(parsedBody as CreateEventResponse);
  }
  const data = contentType.includes("json") ? CreateEventResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as createEventResponseSuccess;
};

const deserializeCreateEventResponse = (data: CreateEventResponse): CreateEventResponse => {
  if (data == null) return data;
  if (data.event != null) {
    if (data.event.end_time != null) {
      data.event.end_time = new Date(data.event.end_time);
    }
    if (data.event.start_time != null) {
      data.event.start_time = new Date(data.event.start_time);
    }
  }
  if (data.event_action_log != null) {
    for (let i0 = 0; i0 < data.event_action_log.length; i0++) {
      const item0 = data.event_action_log[i0]!;
      item0.occurred_at = new Date(item0.occurred_at);
    }
  }
  if (data.event_participants != null) {
    for (let i0 = 0; i0 < data.event_participants.length; i0++) {
      const item0 = data.event_participants[i0]!;
      if (item0.profile != null) {
        item0.profile.created_at = new Date(item0.profile.created_at);
      }
      item0.responded_at = new Date(item0.responded_at);
    }
  }
  return data;
};

export const getCreateEventMutationKey = () => ["createEvent"] as const;

export const getCreateEventMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEvent>>,
      TError,
      CreateEventMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  CreateEventMutationVariables,
  TContext
> => {
  const mutationKey = getCreateEventMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEvent>>,
    CreateEventMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createEvent(data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof createEvent>>,
    variables: CreateEventMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.resetQueries({
        predicate: (query) =>
          [
            getListEventsQueryKey(),
            getListEventsInfiniteQueryKey(),
            getListAccountEventsQueryKey("@me"),
            getListAccountEventsInfiniteQueryKey("@me"),
          ].some((queryKey) => matchQuery({ queryKey }, query)),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type CreateEventMutationResult = NonNullable<Awaited<ReturnType<typeof createEvent>>>;
export type CreateEventMutationBody = CreateEventRequest;
export type CreateEventMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateEventMutationVariables = { data: CreateEventRequest };

/**
 * @summary Create Event
 */
export const useCreateEvent = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEvent>>,
      TError,
      CreateEventMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  CreateEventMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getCreateEventMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type getEventResponse200 = {
  data: GetEventResponseOutput;
  status: 200;
};

export type getEventResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type getEventResponseSuccess = getEventResponse200 & {
  headers: Headers;
};
export type getEventResponseError = getEventResponse404 & {
  headers: Headers;
};

export const getGetEventUrl = (eventId: number, params?: GetEventParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/events/${eventId}?${stringifiedParams}`
    : `/api/v1/events/${eventId}`;
};

/**
 * Get all details of an event. Only events visible to the authenticated user can be retrieved.
 * @summary Get Event
 */
export const getEvent = async (
  eventId: number,
  params?: GetEventParams,
  options?: RequestInit,
): Promise<getEventResponseSuccess> => {
  const res = await fetch(getGetEventUrl(eventId, params), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: getEventResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: getEventResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeGetEventResponse(parsedBody as GetEventResponse);
  }
  const data = contentType.includes("json") ? GetEventResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as getEventResponseSuccess;
};

const deserializeGetEventResponse = (data: GetEventResponse): GetEventResponse => {
  if (data == null) return data;
  if (data.event != null) {
    if (data.event.end_time != null) {
      data.event.end_time = new Date(data.event.end_time);
    }
    if (data.event.start_time != null) {
      data.event.start_time = new Date(data.event.start_time);
    }
  }
  if (data.event_participants != null) {
    for (let i0 = 0; i0 < data.event_participants.length; i0++) {
      const item0 = data.event_participants[i0]!;
      if (item0.profile != null) {
        item0.profile.created_at = new Date(item0.profile.created_at);
      }
      item0.responded_at = new Date(item0.responded_at);
    }
  }
  return data;
};

export const getGetEventQueryKey = (eventId: number, params?: GetEventParams) => {
  return [`/api/v1/events/${eventId}`, ...(params ? [params] : [])] as const;
};

export const getGetEventQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: GetEventParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEventQueryKey(eventId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvent>>> = ({ signal }) =>
    getEvent(eventId, params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: eventId !== null && eventId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetEventQueryResult = NonNullable<Awaited<ReturnType<typeof getEvent>>>;
export type GetEventQueryError = globalThis.Error & { info?: ErrorDetailResponse; status?: number };

export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params: undefined | GetEventParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: GetEventParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: GetEventParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Event
 */

export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: GetEventParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEventQueryOptions(eventId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useGetEvent} query
 */
export const invalidateGetEvent = async (
  queryClient: QueryClient,
  eventId: number,
  params?: GetEventParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetEventQueryKey(eventId, params) }, options);

  return queryClient;
};

export const getGetEventSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: GetEventParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEventQueryKey(eventId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvent>>> = ({ signal }) =>
    getEvent(eventId, params, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type GetEventSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEvent>>>;
export type GetEventSuspenseQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useGetEventSuspense<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params: undefined | GetEventParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEventSuspense<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: GetEventParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEventSuspense<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: GetEventParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Event
 */

export function useGetEventSuspense<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: GetEventParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEventSuspenseQueryOptions(eventId, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateEventResponse200 = {
  data: UpdateEventResponseOutput;
  status: 200;
};

export type updateEventResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateEventResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateEventResponseSuccess = updateEventResponse200 & {
  headers: Headers;
};
export type updateEventResponseError = (updateEventResponse404 | updateEventResponse422) & {
  headers: Headers;
};

export const getUpdateEventUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}`;
};

/**
 * Update details of an event. You can only update events that you created. Event discoverability
 * is managed via [`update_event_participation`](#tag/events/PUT/api/v1/events/{event_id}/participation/{account_id}).
 * @summary Update Event
 */
export const updateEvent = async (
  eventId: number,
  updateEventRequest: UpdateEventRequest,
  options?: RequestInit,
): Promise<updateEventResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateEventUrl(eventId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEventRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: updateEventResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: updateEventResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeUpdateEventResponse(parsedBody as UpdateEventResponse);
  }
  const data = contentType.includes("json") ? UpdateEventResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateEventResponseSuccess;
};

const deserializeUpdateEventResponse = (data: UpdateEventResponse): UpdateEventResponse => {
  if (data == null) return data;
  if (data.event != null) {
    if (data.event.end_time != null) {
      data.event.end_time = new Date(data.event.end_time);
    }
    if (data.event.start_time != null) {
      data.event.start_time = new Date(data.event.start_time);
    }
  }
  return data;
};

export const getUpdateEventMutationKey = () => ["updateEvent"] as const;

export const getUpdateEventMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEvent>>,
      TError,
      UpdateEventMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof updateEvent>>,
  TError,
  UpdateEventMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateEventMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEvent>>,
    UpdateEventMutationVariables
  > = (props) => {
    const { eventId, data } = props ?? {};

    return updateEvent(eventId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof updateEvent>>,
    variables: UpdateEventMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getGetEventQueryKey(variables.eventId) });
      queryClient.resetQueries({
        predicate: (query) =>
          [
            getListEventsQueryKey(),
            getListEventsInfiniteQueryKey(),
            getListAccountEventsQueryKey("@me"),
            getListAccountEventsInfiniteQueryKey("@me"),
          ].some((queryKey) => matchQuery({ queryKey }, query)),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type UpdateEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateEvent>>>;
export type UpdateEventMutationBody = UpdateEventRequest;
export type UpdateEventMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateEventMutationVariables = { eventId: number; data: UpdateEventRequest };

/**
 * @summary Update Event
 */
export const useUpdateEvent = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEvent>>,
      TError,
      UpdateEventMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEvent>>,
  TError,
  UpdateEventMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getUpdateEventMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type deleteEventResponse204 = {
  data: void;
  status: 204;
};

export type deleteEventResponseSuccess = deleteEventResponse204 & {
  headers: Headers;
};

export const getDeleteEventUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}`;
};

/**
 * Delete an event completely, along with all associated data. This is not reversible. Participants
 * are not notified. Only the host of an event may delete it.
 * @summary Delete Invite
 */
export const deleteEvent = async (
  eventId: number,
  options?: RequestInit,
): Promise<deleteEventResponseSuccess> => {
  const res = await fetch(getDeleteEventUrl(eventId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteEventResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as deleteEventResponseSuccess;
};

export const getDeleteEventMutationKey = () => ["deleteEvent"] as const;

export const getDeleteEventMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEvent>>,
      TError,
      DeleteEventMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEvent>>,
  TError,
  DeleteEventMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteEventMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEvent>>,
    DeleteEventMutationVariables
  > = (props) => {
    const { eventId } = props ?? {};

    return deleteEvent(eventId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof deleteEvent>>,
    variables: DeleteEventMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getGetEventQueryKey(variables.eventId) });
      queryClient.resetQueries({
        predicate: (query) =>
          [
            getListEventsQueryKey(),
            getListEventsInfiniteQueryKey(),
            getListAccountEventsQueryKey("@me"),
            getListAccountEventsInfiniteQueryKey("@me"),
          ].some((queryKey) => matchQuery({ queryKey }, query)),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type DeleteEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEvent>>>;

export type DeleteEventMutationError = globalThis.Error & { info?: unknown; status?: number };
export type DeleteEventMutationVariables = { eventId: number };

/**
 * @summary Delete Invite
 */
export const useDeleteEvent = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEvent>>,
      TError,
      DeleteEventMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEvent>>,
  TError,
  DeleteEventMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getDeleteEventMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type listEventActionLogEntriesResponse200 = {
  data: ListEventActionLogEntriesResponseOutput;
  status: 200;
};

export type listEventActionLogEntriesResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type listEventActionLogEntriesResponseSuccess = listEventActionLogEntriesResponse200 & {
  headers: Headers;
};
export type listEventActionLogEntriesResponseError = listEventActionLogEntriesResponse404 & {
  headers: Headers;
};

export const getListEventActionLogEntriesUrl = (
  eventId: number,
  params?: ListEventActionLogEntriesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/events/${eventId}/action-logs?${stringifiedParams}`
    : `/api/v1/events/${eventId}/action-logs`;
};

/**
 * Get the action log for an event. This includes all the comments on the event, along with any
 * other relevant actions in the timeline.
 *
 * Log entries are listed in order from newest to oldest. There may be more entries in the response
 * than the requested limit, as replies to comments are not counted toward the limit; all replies to
 * any top level comment in the response are included.
 * @summary List Event Action Log Entries
 */
export const listEventActionLogEntries = async (
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: RequestInit,
): Promise<listEventActionLogEntriesResponseSuccess> => {
  const res = await fetch(getListEventActionLogEntriesUrl(eventId, params), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: listEventActionLogEntriesResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: listEventActionLogEntriesResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeListEventActionLogEntriesResponse(
      parsedBody as ListEventActionLogEntriesResponse,
    );
  }
  const data = contentType.includes("json")
    ? ListEventActionLogEntriesResponse.parse(parsedBody)
    : parsedBody;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as listEventActionLogEntriesResponseSuccess;
};

const deserializeListEventActionLogEntriesResponse = (
  data: ListEventActionLogEntriesResponse,
): ListEventActionLogEntriesResponse => {
  if (data == null) return data;
  if (data.event_action_log != null) {
    for (let i0 = 0; i0 < data.event_action_log.length; i0++) {
      const item0 = data.event_action_log[i0]!;
      item0.occurred_at = new Date(item0.occurred_at);
    }
  }
  return data;
};

export const getListEventActionLogEntriesInfiniteQueryKey = (
  eventId: number,
  params?: ListEventActionLogEntriesParams,
) => {
  return [
    "infinite",
    `/api/v1/events/${eventId}/action-logs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListEventActionLogEntriesQueryKey = (
  eventId: number,
  params?: ListEventActionLogEntriesParams,
) => {
  return [`/api/v1/events/${eventId}/action-logs`, ...(params ? [params] : [])] as const;
};

export const getListEventActionLogEntriesInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    ListEventActionLogEntriesParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEventActionLogEntries>>,
        TError,
        TData,
        QueryKey,
        ListEventActionLogEntriesParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListEventActionLogEntriesInfiniteQueryKey(eventId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    QueryKey,
    ListEventActionLogEntriesParams["after_cursor"]
  > = ({ signal, pageParam }) =>
    listEventActionLogEntries(
      eventId,
      { ...params, after_cursor: pageParam ?? params?.["after_cursor"] },
      { signal, ...fetchOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: eventId !== null && eventId !== undefined,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    TError,
    TData,
    QueryKey,
    ListEventActionLogEntriesParams["after_cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEventActionLogEntriesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEventActionLogEntries>>
>;
export type ListEventActionLogEntriesInfiniteQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useListEventActionLogEntriesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    ListEventActionLogEntriesParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params: undefined | ListEventActionLogEntriesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEventActionLogEntries>>,
        TError,
        TData,
        QueryKey,
        ListEventActionLogEntriesParams["after_cursor"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventActionLogEntries>>,
          TError,
          Awaited<ReturnType<typeof listEventActionLogEntries>>,
          QueryKey
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventActionLogEntriesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    ListEventActionLogEntriesParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEventActionLogEntries>>,
        TError,
        TData,
        QueryKey,
        ListEventActionLogEntriesParams["after_cursor"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventActionLogEntries>>,
          TError,
          Awaited<ReturnType<typeof listEventActionLogEntries>>,
          QueryKey
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventActionLogEntriesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    ListEventActionLogEntriesParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEventActionLogEntries>>,
        TError,
        TData,
        QueryKey,
        ListEventActionLogEntriesParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Event Action Log Entries
 */

export function useListEventActionLogEntriesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    ListEventActionLogEntriesParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEventActionLogEntries>>,
        TError,
        TData,
        QueryKey,
        ListEventActionLogEntriesParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventActionLogEntriesInfiniteQueryOptions(eventId, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListEventActionLogEntriesInfinite} query
 */
export const invalidateListEventActionLogEntriesInfinite = async (
  queryClient: QueryClient,
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getListEventActionLogEntriesInfiniteQueryKey(eventId, params) },
    options,
  );

  return queryClient;
};

export const getListEventActionLogEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listEventActionLogEntries>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventActionLogEntriesQueryKey(eventId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEventActionLogEntries>>> = ({
    signal,
  }) => listEventActionLogEntries(eventId, params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: eventId !== null && eventId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListEventActionLogEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEventActionLogEntries>>
>;
export type ListEventActionLogEntriesQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useListEventActionLogEntries<
  TData = Awaited<ReturnType<typeof listEventActionLogEntries>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params: undefined | ListEventActionLogEntriesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventActionLogEntries>>,
          TError,
          Awaited<ReturnType<typeof listEventActionLogEntries>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventActionLogEntries<
  TData = Awaited<ReturnType<typeof listEventActionLogEntries>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventActionLogEntries>>,
          TError,
          Awaited<ReturnType<typeof listEventActionLogEntries>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventActionLogEntries<
  TData = Awaited<ReturnType<typeof listEventActionLogEntries>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Event Action Log Entries
 */

export function useListEventActionLogEntries<
  TData = Awaited<ReturnType<typeof listEventActionLogEntries>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventActionLogEntriesQueryOptions(eventId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListEventActionLogEntries} query
 */
export const invalidateListEventActionLogEntries = async (
  queryClient: QueryClient,
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getListEventActionLogEntriesQueryKey(eventId, params) },
    options,
  );

  return queryClient;
};

export const getListEventActionLogEntriesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listEventActionLogEntries>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventActionLogEntriesQueryKey(eventId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEventActionLogEntries>>> = ({
    signal,
  }) => listEventActionLogEntries(eventId, params, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListEventActionLogEntriesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEventActionLogEntries>>
>;
export type ListEventActionLogEntriesSuspenseQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useListEventActionLogEntriesSuspense<
  TData = Awaited<ReturnType<typeof listEventActionLogEntries>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params: undefined | ListEventActionLogEntriesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventActionLogEntriesSuspense<
  TData = Awaited<ReturnType<typeof listEventActionLogEntries>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventActionLogEntriesSuspense<
  TData = Awaited<ReturnType<typeof listEventActionLogEntries>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Event Action Log Entries
 */

export function useListEventActionLogEntriesSuspense<
  TData = Awaited<ReturnType<typeof listEventActionLogEntries>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventActionLogEntries>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventActionLogEntriesSuspenseQueryOptions(eventId, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListEventActionLogEntriesSuspenseInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    ListEventActionLogEntriesParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEventActionLogEntries>>,
        TError,
        TData,
        QueryKey,
        ListEventActionLogEntriesParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListEventActionLogEntriesInfiniteQueryKey(eventId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    QueryKey,
    ListEventActionLogEntriesParams["after_cursor"]
  > = ({ signal, pageParam }) =>
    listEventActionLogEntries(
      eventId,
      { ...params, after_cursor: pageParam ?? params?.["after_cursor"] },
      { signal, ...fetchOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    TError,
    TData,
    QueryKey,
    ListEventActionLogEntriesParams["after_cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEventActionLogEntriesSuspenseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEventActionLogEntries>>
>;
export type ListEventActionLogEntriesSuspenseInfiniteQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useListEventActionLogEntriesSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    ListEventActionLogEntriesParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params: undefined | ListEventActionLogEntriesParams,
  options: {
    query: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEventActionLogEntries>>,
        TError,
        TData,
        QueryKey,
        ListEventActionLogEntriesParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventActionLogEntriesSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    ListEventActionLogEntriesParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEventActionLogEntries>>,
        TError,
        TData,
        QueryKey,
        ListEventActionLogEntriesParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventActionLogEntriesSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    ListEventActionLogEntriesParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEventActionLogEntries>>,
        TError,
        TData,
        QueryKey,
        ListEventActionLogEntriesParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Event Action Log Entries
 */

export function useListEventActionLogEntriesSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listEventActionLogEntries>>,
    ListEventActionLogEntriesParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  params?: ListEventActionLogEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listEventActionLogEntries>>,
        TError,
        TData,
        QueryKey,
        ListEventActionLogEntriesParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventActionLogEntriesSuspenseInfiniteQueryOptions(
    eventId,
    params,
    options,
  );

  const query = useSuspenseInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createEventCommentResponse200 = {
  data: CreateEventCommentResponseOutput;
  status: 200;
};

export type createEventCommentResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type createEventCommentResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createEventCommentResponseSuccess = createEventCommentResponse200 & {
  headers: Headers;
};
export type createEventCommentResponseError = (
  | createEventCommentResponse404
  | createEventCommentResponse422
) & {
  headers: Headers;
};

export const getCreateEventCommentUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}/comment`;
};

/**
 * Leave a comment on an event.
 * @summary Create Event Comment
 */
export const createEventComment = async (
  eventId: number,
  createEventCommentRequest: CreateEventCommentRequest,
  options?: RequestInit,
): Promise<createEventCommentResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateEventCommentUrl(eventId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createEventCommentRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: createEventCommentResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: createEventCommentResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeCreateEventCommentResponse(parsedBody as CreateEventCommentResponse);
  }
  const data = contentType.includes("json")
    ? CreateEventCommentResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as createEventCommentResponseSuccess;
};

const deserializeCreateEventCommentResponse = (
  data: CreateEventCommentResponse,
): CreateEventCommentResponse => {
  if (data == null) return data;
  if (data.event_comment != null) {
    data.event_comment.occurred_at = new Date(data.event_comment.occurred_at);
  }
  return data;
};

export const getCreateEventCommentMutationKey = () => ["createEventComment"] as const;

export const getCreateEventCommentMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEventComment>>,
      TError,
      CreateEventCommentMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof createEventComment>>,
  TError,
  CreateEventCommentMutationVariables,
  TContext
> => {
  const mutationKey = getCreateEventCommentMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEventComment>>,
    CreateEventCommentMutationVariables
  > = (props) => {
    const { eventId, data } = props ?? {};

    return createEventComment(eventId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof createEventComment>>,
    variables: CreateEventCommentMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          [
            getListEventActionLogEntriesQueryKey(variables.eventId),
            getListEventActionLogEntriesInfiniteQueryKey(variables.eventId),
          ].some((queryKey) => matchQuery({ queryKey }, query)),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type CreateEventCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEventComment>>
>;
export type CreateEventCommentMutationBody = CreateEventCommentRequest;
export type CreateEventCommentMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateEventCommentMutationVariables = {
  eventId: number;
  data: CreateEventCommentRequest;
};

/**
 * @summary Create Event Comment
 */
export const useCreateEventComment = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEventComment>>,
      TError,
      CreateEventCommentMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEventComment>>,
  TError,
  CreateEventCommentMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getCreateEventCommentMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type createEventDirectionsResponse200 = {
  data: CreateEventDirectionsResponseOutput;
  status: 200;
};

export type createEventDirectionsResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type createEventDirectionsResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createEventDirectionsResponseSuccess = createEventDirectionsResponse200 & {
  headers: Headers;
};
export type createEventDirectionsResponseError = (
  | createEventDirectionsResponse404
  | createEventDirectionsResponse422
) & {
  headers: Headers;
};

export const getCreateEventDirectionsUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}/directions`;
};

/**
 * Create map pin and arrival instructions for an event. You can only create widgets
 * for events that you created.
 * @summary Create Event Directions
 */
export const createEventDirections = async (
  eventId: number,
  createEventDirectionsRequest: CreateEventDirectionsRequest,
  options?: RequestInit,
): Promise<createEventDirectionsResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateEventDirectionsUrl(eventId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createEventDirectionsRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: createEventDirectionsResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: createEventDirectionsResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? CreateEventDirectionsResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as createEventDirectionsResponseSuccess;
};

export const getCreateEventDirectionsMutationKey = () => ["createEventDirections"] as const;

export const getCreateEventDirectionsMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEventDirections>>,
    TError,
    CreateEventDirectionsMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEventDirections>>,
  TError,
  CreateEventDirectionsMutationVariables,
  TContext
> => {
  const mutationKey = getCreateEventDirectionsMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEventDirections>>,
    CreateEventDirectionsMutationVariables
  > = (props) => {
    const { eventId, data } = props ?? {};

    return createEventDirections(eventId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventDirectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEventDirections>>
>;
export type CreateEventDirectionsMutationBody = CreateEventDirectionsRequest;
export type CreateEventDirectionsMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateEventDirectionsMutationVariables = {
  eventId: number;
  data: CreateEventDirectionsRequest;
};

/**
 * @summary Create Event Directions
 */
export const useCreateEventDirections = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEventDirections>>,
      TError,
      CreateEventDirectionsMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEventDirections>>,
  TError,
  CreateEventDirectionsMutationVariables,
  TContext
> => {
  return useMutation(getCreateEventDirectionsMutationOptions(options), queryClient);
};

export type listEventInviteCodesResponse200 = {
  data: ListEventInviteCodesResponseOutput;
  status: 200;
};

export type listEventInviteCodesResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type listEventInviteCodesResponseSuccess = listEventInviteCodesResponse200 & {
  headers: Headers;
};
export type listEventInviteCodesResponseError = listEventInviteCodesResponse404 & {
  headers: Headers;
};

export const getListEventInviteCodesUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}/invite-codes`;
};

/**
 * Lists all invite-codes codes you have created for this event.
 * @summary List Event Invite Codes
 */
export const listEventInviteCodes = async (
  eventId: number,
  options?: RequestInit,
): Promise<listEventInviteCodesResponseSuccess> => {
  const res = await fetch(getListEventInviteCodesUrl(eventId), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: listEventInviteCodesResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: listEventInviteCodesResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? ListEventInviteCodesResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as listEventInviteCodesResponseSuccess;
};

export const getListEventInviteCodesQueryKey = (eventId: number) => {
  return [`/api/v1/events/${eventId}/invite-codes`] as const;
};

export const getListEventInviteCodesQueryOptions = <
  TData = Awaited<ReturnType<typeof listEventInviteCodes>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventInviteCodesQueryKey(eventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEventInviteCodes>>> = ({ signal }) =>
    listEventInviteCodes(eventId, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: eventId !== null && eventId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListEventInviteCodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEventInviteCodes>>
>;
export type ListEventInviteCodesQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useListEventInviteCodes<
  TData = Awaited<ReturnType<typeof listEventInviteCodes>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventInviteCodes>>,
          TError,
          Awaited<ReturnType<typeof listEventInviteCodes>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventInviteCodes<
  TData = Awaited<ReturnType<typeof listEventInviteCodes>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventInviteCodes>>,
          TError,
          Awaited<ReturnType<typeof listEventInviteCodes>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventInviteCodes<
  TData = Awaited<ReturnType<typeof listEventInviteCodes>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Event Invite Codes
 */

export function useListEventInviteCodes<
  TData = Awaited<ReturnType<typeof listEventInviteCodes>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventInviteCodesQueryOptions(eventId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListEventInviteCodes} query
 */
export const invalidateListEventInviteCodes = async (
  queryClient: QueryClient,
  eventId: number,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getListEventInviteCodesQueryKey(eventId) },
    options,
  );

  return queryClient;
};

export const getListEventInviteCodesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listEventInviteCodes>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventInviteCodesQueryKey(eventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEventInviteCodes>>> = ({ signal }) =>
    listEventInviteCodes(eventId, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListEventInviteCodesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEventInviteCodes>>
>;
export type ListEventInviteCodesSuspenseQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useListEventInviteCodesSuspense<
  TData = Awaited<ReturnType<typeof listEventInviteCodes>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventInviteCodesSuspense<
  TData = Awaited<ReturnType<typeof listEventInviteCodes>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventInviteCodesSuspense<
  TData = Awaited<ReturnType<typeof listEventInviteCodes>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Event Invite Codes
 */

export function useListEventInviteCodesSuspense<
  TData = Awaited<ReturnType<typeof listEventInviteCodes>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInviteCodes>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventInviteCodesSuspenseQueryOptions(eventId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createEventInviteCodeResponse200 = {
  data: CreateEventInviteCodeResponseOutput;
  status: 200;
};

export type createEventInviteCodeResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createEventInviteCodeResponseSuccess = createEventInviteCodeResponse200 & {
  headers: Headers;
};
export type createEventInviteCodeResponseError = createEventInviteCodeResponse422 & {
  headers: Headers;
};

export const getCreateEventInviteCodeUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}/invite-codes`;
};

/**
 * Create an invite code which allows inviting anyone with the link to the event, even without an
 * existing Bale account.
 * @summary Create Event Invite Code
 */
export const createEventInviteCode = async (
  eventId: number,
  options?: RequestInit,
): Promise<createEventInviteCodeResponseSuccess> => {
  const res = await fetch(getCreateEventInviteCodeUrl(eventId), {
    ...options,
    method: "POST",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: createEventInviteCodeResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: createEventInviteCodeResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? CreateEventInviteCodeResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as createEventInviteCodeResponseSuccess;
};

export const getCreateEventInviteCodeMutationKey = () => ["createEventInviteCode"] as const;

export const getCreateEventInviteCodeMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEventInviteCode>>,
      TError,
      CreateEventInviteCodeMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof createEventInviteCode>>,
  TError,
  CreateEventInviteCodeMutationVariables,
  TContext
> => {
  const mutationKey = getCreateEventInviteCodeMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEventInviteCode>>,
    CreateEventInviteCodeMutationVariables
  > = (props) => {
    const { eventId } = props ?? {};

    return createEventInviteCode(eventId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof createEventInviteCode>>,
    variables: CreateEventInviteCodeMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" && query.queryKey[0].startsWith("/api/v1/events/"),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type CreateEventInviteCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEventInviteCode>>
>;

export type CreateEventInviteCodeMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateEventInviteCodeMutationVariables = { eventId: number };

/**
 * @summary Create Event Invite Code
 */
export const useCreateEventInviteCode = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEventInviteCode>>,
      TError,
      CreateEventInviteCodeMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEventInviteCode>>,
  TError,
  CreateEventInviteCodeMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getCreateEventInviteCodeMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type listEventInvitesResponse200 = {
  data: ListEventInvitesResponseOutput;
  status: 200;
};

export type listEventInvitesResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type listEventInvitesResponseSuccess = listEventInvitesResponse200 & {
  headers: Headers;
};
export type listEventInvitesResponseError = listEventInvitesResponse404 & {
  headers: Headers;
};

export const getListEventInvitesUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}/invites`;
};

/**
 * Lists all invites to this event. This may include invites that have been
 * accepted, as well as invites sent by other users.
 * @summary List Event Invites
 */
export const listEventInvites = async (
  eventId: number,
  options?: RequestInit,
): Promise<listEventInvitesResponseSuccess> => {
  const res = await fetch(getListEventInvitesUrl(eventId), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: listEventInvitesResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: listEventInvitesResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeListEventInvitesResponse(parsedBody as ListEventInvitesResponse);
  }
  const data = contentType.includes("json")
    ? ListEventInvitesResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as listEventInvitesResponseSuccess;
};

const deserializeListEventInvitesResponse = (
  data: ListEventInvitesResponse,
): ListEventInvitesResponse => {
  if (data == null) return data;
  if (data.event_invites != null) {
    for (let i0 = 0; i0 < data.event_invites.length; i0++) {
      const item0 = data.event_invites[i0]!;
      if (item0.invited != null) {
        item0.invited.created_at = new Date(item0.invited.created_at);
      }
    }
  }
  return data;
};

export const getListEventInvitesQueryKey = (eventId: number) => {
  return [`/api/v1/events/${eventId}/invites`] as const;
};

export const getListEventInvitesQueryOptions = <
  TData = Awaited<ReturnType<typeof listEventInvites>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventInvitesQueryKey(eventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEventInvites>>> = ({ signal }) =>
    listEventInvites(eventId, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: eventId !== null && eventId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListEventInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listEventInvites>>>;
export type ListEventInvitesQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useListEventInvites<
  TData = Awaited<ReturnType<typeof listEventInvites>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventInvites>>,
          TError,
          Awaited<ReturnType<typeof listEventInvites>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventInvites<
  TData = Awaited<ReturnType<typeof listEventInvites>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventInvites>>,
          TError,
          Awaited<ReturnType<typeof listEventInvites>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventInvites<
  TData = Awaited<ReturnType<typeof listEventInvites>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Event Invites
 */

export function useListEventInvites<
  TData = Awaited<ReturnType<typeof listEventInvites>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventInvitesQueryOptions(eventId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListEventInvites} query
 */
export const invalidateListEventInvites = async (
  queryClient: QueryClient,
  eventId: number,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListEventInvitesQueryKey(eventId) }, options);

  return queryClient;
};

export const getListEventInvitesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listEventInvites>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventInvitesQueryKey(eventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEventInvites>>> = ({ signal }) =>
    listEventInvites(eventId, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListEventInvitesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEventInvites>>
>;
export type ListEventInvitesSuspenseQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useListEventInvitesSuspense<
  TData = Awaited<ReturnType<typeof listEventInvites>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventInvitesSuspense<
  TData = Awaited<ReturnType<typeof listEventInvites>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventInvitesSuspense<
  TData = Awaited<ReturnType<typeof listEventInvites>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Event Invites
 */

export function useListEventInvitesSuspense<
  TData = Awaited<ReturnType<typeof listEventInvites>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventInvites>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventInvitesSuspenseQueryOptions(eventId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateEventInviteResponse200 = {
  data: UpdateEventInviteResponseOutput;
  status: 200;
};

export type updateEventInviteResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateEventInviteResponseSuccess = updateEventInviteResponse200 & {
  headers: Headers;
};
export type updateEventInviteResponseError = updateEventInviteResponse422 & {
  headers: Headers;
};

export const getUpdateEventInviteUrl = (eventId: number, accountId: string) => {
  return `/api/v1/events/${eventId}/invites/${accountId}`;
};

/**
 * Create or update an invite to this event. You must be a participant in the event, and have a sufficient
 * discoverable distance limit for your invite to be seen.
 * @summary Update Event Invite
 */
export const updateEventInvite = async (
  eventId: number,
  accountId: string,
  updateEventInviteRequest: UpdateEventInviteRequest,
  options?: RequestInit,
): Promise<updateEventInviteResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateEventInviteUrl(eventId, accountId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEventInviteRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: updateEventInviteResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: updateEventInviteResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeUpdateEventInviteResponse(parsedBody as UpdateEventInviteResponse);
  }
  const data = contentType.includes("json")
    ? UpdateEventInviteResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateEventInviteResponseSuccess;
};

const deserializeUpdateEventInviteResponse = (
  data: UpdateEventInviteResponse,
): UpdateEventInviteResponse => {
  if (data == null) return data;
  if (data.event_invite != null) {
    if (data.event_invite.invited != null) {
      data.event_invite.invited.created_at = new Date(data.event_invite.invited.created_at);
    }
  }
  return data;
};

export const getUpdateEventInviteMutationKey = () => ["updateEventInvite"] as const;

export const getUpdateEventInviteMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventInvite>>,
      TError,
      UpdateEventInviteMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof updateEventInvite>>,
  TError,
  UpdateEventInviteMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateEventInviteMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEventInvite>>,
    UpdateEventInviteMutationVariables
  > = (props) => {
    const { eventId, accountId, data } = props ?? {};

    return updateEventInvite(eventId, accountId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof updateEventInvite>>,
    variables: UpdateEventInviteMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListEventInvitesQueryKey(variables.eventId) });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type UpdateEventInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEventInvite>>
>;
export type UpdateEventInviteMutationBody = UpdateEventInviteRequest;
export type UpdateEventInviteMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateEventInviteMutationVariables = {
  eventId: number;
  accountId: string;
  data: UpdateEventInviteRequest;
};

/**
 * @summary Update Event Invite
 */
export const useUpdateEventInvite = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventInvite>>,
      TError,
      UpdateEventInviteMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEventInvite>>,
  TError,
  UpdateEventInviteMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getUpdateEventInviteMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type deleteEventInviteResponse204 = {
  data: void;
  status: 204;
};

export type deleteEventInviteResponseSuccess = deleteEventInviteResponse204 & {
  headers: Headers;
};

export const getDeleteEventInviteUrl = (eventId: number, accountId: string) => {
  return `/api/v1/events/${eventId}/invites/${accountId}`;
};

/**
 * Delete an invite to this event. If the person has already accepted this invite, removing
 * the invite does not remove them from the event, but does potentially change the
 * discoverability distance of their further invitations, as they will no longer receive
 * the discoverability from your invite chain.
 * @summary Delete Event Invite
 */
export const deleteEventInvite = async (
  eventId: number,
  accountId: string,
  options?: RequestInit,
): Promise<deleteEventInviteResponseSuccess> => {
  const res = await fetch(getDeleteEventInviteUrl(eventId, accountId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteEventInviteResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as deleteEventInviteResponseSuccess;
};

export const getDeleteEventInviteMutationKey = () => ["deleteEventInvite"] as const;

export const getDeleteEventInviteMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEventInvite>>,
      TError,
      DeleteEventInviteMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEventInvite>>,
  TError,
  DeleteEventInviteMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteEventInviteMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEventInvite>>,
    DeleteEventInviteMutationVariables
  > = (props) => {
    const { eventId, accountId } = props ?? {};

    return deleteEventInvite(eventId, accountId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof deleteEventInvite>>,
    variables: DeleteEventInviteMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListEventInvitesQueryKey(variables.eventId) });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type DeleteEventInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEventInvite>>
>;

export type DeleteEventInviteMutationError = globalThis.Error & { info?: unknown; status?: number };
export type DeleteEventInviteMutationVariables = { eventId: number; accountId: string };

/**
 * @summary Delete Event Invite
 */
export const useDeleteEventInvite = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEventInvite>>,
      TError,
      DeleteEventInviteMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEventInvite>>,
  TError,
  DeleteEventInviteMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getDeleteEventInviteMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type createEventNoteResponse200 = {
  data: CreateEventNoteResponseOutput;
  status: 200;
};

export type createEventNoteResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type createEventNoteResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createEventNoteResponseSuccess = createEventNoteResponse200 & {
  headers: Headers;
};
export type createEventNoteResponseError = (
  | createEventNoteResponse404
  | createEventNoteResponse422
) & {
  headers: Headers;
};

export const getCreateEventNoteUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}/notes`;
};

/**
 * Create a generic additional note widget for an event. You can only create widgets
 * for events that you created.
 * @summary Create Event Note
 */
export const createEventNote = async (
  eventId: number,
  createEventNoteRequest: CreateEventNoteRequest,
  options?: RequestInit,
): Promise<createEventNoteResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateEventNoteUrl(eventId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createEventNoteRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: createEventNoteResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: createEventNoteResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? CreateEventNoteResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as createEventNoteResponseSuccess;
};

export const getCreateEventNoteMutationKey = () => ["createEventNote"] as const;

export const getCreateEventNoteMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEventNote>>,
    TError,
    CreateEventNoteMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEventNote>>,
  TError,
  CreateEventNoteMutationVariables,
  TContext
> => {
  const mutationKey = getCreateEventNoteMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEventNote>>,
    CreateEventNoteMutationVariables
  > = (props) => {
    const { eventId, data } = props ?? {};

    return createEventNote(eventId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEventNote>>
>;
export type CreateEventNoteMutationBody = CreateEventNoteRequest;
export type CreateEventNoteMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateEventNoteMutationVariables = { eventId: number; data: CreateEventNoteRequest };

/**
 * @summary Create Event Note
 */
export const useCreateEventNote = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEventNote>>,
      TError,
      CreateEventNoteMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEventNote>>,
  TError,
  CreateEventNoteMutationVariables,
  TContext
> => {
  return useMutation(getCreateEventNoteMutationOptions(options), queryClient);
};

export type updateEventParticipationResponse200 = {
  data: UpdateEventParticipationResponseOutput;
  status: 200;
};

export type updateEventParticipationResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateEventParticipationResponseSuccess = updateEventParticipationResponse200 & {
  headers: Headers;
};
export type updateEventParticipationResponseError = updateEventParticipationResponse404 & {
  headers: Headers;
};

export const getUpdateEventParticipationUrl = (eventId: number, accountId: AccountIdOrMe) => {
  return `/api/v1/events/${eventId}/participation/${accountId}`;
};

/**
 * Update an account's participation in an event. If you've updated the participation, then you are participating.
 * Stop participating by using [`delete_event_participation`](#tag/events/DELETE/api/v1/events/{event_id}/participation/{account_id}).
 * @summary Update Event Participation
 */
export const updateEventParticipation = async (
  eventId: number,
  accountId: AccountIdOrMe,
  updateEventParticipationRequest: UpdateEventParticipationRequest,
  options?: RequestInit,
): Promise<updateEventParticipationResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateEventParticipationUrl(eventId, accountId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEventParticipationRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: updateEventParticipationResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: updateEventParticipationResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeUpdateEventParticipationResponse(
      parsedBody as UpdateEventParticipationResponse,
    );
  }
  const data = contentType.includes("json")
    ? UpdateEventParticipationResponse.parse(parsedBody)
    : parsedBody;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as updateEventParticipationResponseSuccess;
};

const deserializeUpdateEventParticipationResponse = (
  data: UpdateEventParticipationResponse,
): UpdateEventParticipationResponse => {
  if (data == null) return data;
  if (data.event_participant != null) {
    if (data.event_participant.profile != null) {
      data.event_participant.profile.created_at = new Date(
        data.event_participant.profile.created_at,
      );
    }
    data.event_participant.responded_at = new Date(data.event_participant.responded_at);
  }
  return data;
};

export const getUpdateEventParticipationMutationKey = () => ["updateEventParticipation"] as const;

export const getUpdateEventParticipationMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventParticipation>>,
      TError,
      UpdateEventParticipationMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof updateEventParticipation>>,
  TError,
  UpdateEventParticipationMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateEventParticipationMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEventParticipation>>,
    UpdateEventParticipationMutationVariables
  > = (props) => {
    const { eventId, accountId, data } = props ?? {};

    return updateEventParticipation(eventId, accountId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof updateEventParticipation>>,
    variables: UpdateEventParticipationMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          [
            getGetEventQueryKey(variables.eventId),
            getListEventInvitesQueryKey(variables.eventId),
            getListEventActionLogEntriesQueryKey(variables.eventId),
            getListEventActionLogEntriesInfiniteQueryKey(variables.eventId),
          ].some((queryKey) => matchQuery({ queryKey }, query)),
      });
      queryClient.resetQueries({
        predicate: (query) =>
          [getListEventsQueryKey(), getListEventsInfiniteQueryKey()].some((queryKey) =>
            matchQuery({ queryKey }, query),
          ),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type UpdateEventParticipationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEventParticipation>>
>;
export type UpdateEventParticipationMutationBody = UpdateEventParticipationRequest;
export type UpdateEventParticipationMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateEventParticipationMutationVariables = {
  eventId: number;
  accountId: AccountIdOrMe;
  data: UpdateEventParticipationRequest;
};

/**
 * @summary Update Event Participation
 */
export const useUpdateEventParticipation = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventParticipation>>,
      TError,
      UpdateEventParticipationMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEventParticipation>>,
  TError,
  UpdateEventParticipationMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getUpdateEventParticipationMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type deleteEventParticipationResponse204 = {
  data: void;
  status: 204;
};

export type deleteEventParticipationResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type deleteEventParticipationResponseSuccess = deleteEventParticipationResponse204 & {
  headers: Headers;
};
export type deleteEventParticipationResponseError = deleteEventParticipationResponse422 & {
  headers: Headers;
};

export const getDeleteEventParticipationUrl = (eventId: number, accountId: AccountIdOrMe) => {
  return `/api/v1/events/${eventId}/participation/${accountId}`;
};

/**
 * Remove a participant from an event. They can still join again. This will also remove any shares or invites
 * that were sent by the person who is no longer a participant.
 *
 * The host cannot delete their own participation from an event.
 * @summary Delete Event Participation
 */
export const deleteEventParticipation = async (
  eventId: number,
  accountId: AccountIdOrMe,
  options?: RequestInit,
): Promise<deleteEventParticipationResponseSuccess> => {
  const res = await fetch(getDeleteEventParticipationUrl(eventId, accountId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: deleteEventParticipationResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: deleteEventParticipationResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteEventParticipationResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as deleteEventParticipationResponseSuccess;
};

export const getDeleteEventParticipationMutationKey = () => ["deleteEventParticipation"] as const;

export const getDeleteEventParticipationMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEventParticipation>>,
      TError,
      DeleteEventParticipationMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEventParticipation>>,
  TError,
  DeleteEventParticipationMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteEventParticipationMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEventParticipation>>,
    DeleteEventParticipationMutationVariables
  > = (props) => {
    const { eventId, accountId } = props ?? {};

    return deleteEventParticipation(eventId, accountId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof deleteEventParticipation>>,
    variables: DeleteEventParticipationMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          [
            getGetEventQueryKey(variables.eventId),
            getListEventInvitesQueryKey(variables.eventId),
            getListEventActionLogEntriesQueryKey(variables.eventId),
            getListEventActionLogEntriesInfiniteQueryKey(variables.eventId),
          ].some((queryKey) => matchQuery({ queryKey }, query)),
      });
      queryClient.resetQueries({
        predicate: (query) =>
          [getListEventsQueryKey(), getListEventsInfiniteQueryKey()].some((queryKey) =>
            matchQuery({ queryKey }, query),
          ),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type DeleteEventParticipationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEventParticipation>>
>;

export type DeleteEventParticipationMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type DeleteEventParticipationMutationVariables = {
  eventId: number;
  accountId: AccountIdOrMe;
};

/**
 * @summary Delete Event Participation
 */
export const useDeleteEventParticipation = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEventParticipation>>,
      TError,
      DeleteEventParticipationMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEventParticipation>>,
  TError,
  DeleteEventParticipationMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getDeleteEventParticipationMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type createEventPollResponse200 = {
  data: CreateEventPollResponseOutput;
  status: 200;
};

export type createEventPollResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type createEventPollResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createEventPollResponseSuccess = createEventPollResponse200 & {
  headers: Headers;
};
export type createEventPollResponseError = (
  | createEventPollResponse404
  | createEventPollResponse422
) & {
  headers: Headers;
};

export const getCreateEventPollUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}/polls`;
};

/**
 * Create a poll for an event. You can only create widgets for events that you created.
 * @summary Create Event Poll
 */
export const createEventPoll = async (
  eventId: number,
  createEventPollRequest: CreateEventPollRequest,
  options?: RequestInit,
): Promise<createEventPollResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateEventPollUrl(eventId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createEventPollRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: createEventPollResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: createEventPollResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? CreateEventPollResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as createEventPollResponseSuccess;
};

export const getCreateEventPollMutationKey = () => ["createEventPoll"] as const;

export const getCreateEventPollMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEventPoll>>,
    TError,
    CreateEventPollMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEventPoll>>,
  TError,
  CreateEventPollMutationVariables,
  TContext
> => {
  const mutationKey = getCreateEventPollMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEventPoll>>,
    CreateEventPollMutationVariables
  > = (props) => {
    const { eventId, data } = props ?? {};

    return createEventPoll(eventId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventPollMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEventPoll>>
>;
export type CreateEventPollMutationBody = CreateEventPollRequest;
export type CreateEventPollMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateEventPollMutationVariables = { eventId: number; data: CreateEventPollRequest };

/**
 * @summary Create Event Poll
 */
export const useCreateEventPoll = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEventPoll>>,
      TError,
      CreateEventPollMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEventPoll>>,
  TError,
  CreateEventPollMutationVariables,
  TContext
> => {
  return useMutation(getCreateEventPollMutationOptions(options), queryClient);
};

export type createEventAbuseReportResponse201 = {
  data: void;
  status: 201;
};

export type createEventAbuseReportResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type createEventAbuseReportResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createEventAbuseReportResponseSuccess = createEventAbuseReportResponse201 & {
  headers: Headers;
};
export type createEventAbuseReportResponseError = (
  | createEventAbuseReportResponse404
  | createEventAbuseReportResponse422
) & {
  headers: Headers;
};

export const getCreateEventAbuseReportUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}/report`;
};

/**
 * Report an event for abuse.
 * @summary Report Event
 */
export const createEventAbuseReport = async (
  eventId: number,
  createEventAbuseReportRequest: CreateEventAbuseReportRequest,
  options?: RequestInit,
): Promise<createEventAbuseReportResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateEventAbuseReportUrl(eventId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createEventAbuseReportRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: createEventAbuseReportResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: createEventAbuseReportResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: createEventAbuseReportResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createEventAbuseReportResponseSuccess;
};

export const getCreateEventAbuseReportMutationKey = () => ["createEventAbuseReport"] as const;

export const getCreateEventAbuseReportMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEventAbuseReport>>,
    TError,
    CreateEventAbuseReportMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEventAbuseReport>>,
  TError,
  CreateEventAbuseReportMutationVariables,
  TContext
> => {
  const mutationKey = getCreateEventAbuseReportMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEventAbuseReport>>,
    CreateEventAbuseReportMutationVariables
  > = (props) => {
    const { eventId, data } = props ?? {};

    return createEventAbuseReport(eventId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventAbuseReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEventAbuseReport>>
>;
export type CreateEventAbuseReportMutationBody = CreateEventAbuseReportRequest;
export type CreateEventAbuseReportMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateEventAbuseReportMutationVariables = {
  eventId: number;
  data: CreateEventAbuseReportRequest;
};

/**
 * @summary Report Event
 */
export const useCreateEventAbuseReport = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEventAbuseReport>>,
      TError,
      CreateEventAbuseReportMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEventAbuseReport>>,
  TError,
  CreateEventAbuseReportMutationVariables,
  TContext
> => {
  return useMutation(getCreateEventAbuseReportMutationOptions(options), queryClient);
};

export type listEventSharesResponse200 = {
  data: ListEventSharesResponseOutput;
  status: 200;
};

export type listEventSharesResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type listEventSharesResponseSuccess = listEventSharesResponse200 & {
  headers: Headers;
};
export type listEventSharesResponseError = listEventSharesResponse404 & {
  headers: Headers;
};

export const getListEventSharesUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}/shares`;
};

/**
 * Lists your shares to this event. You are not able to see shares by other users.
 * @summary List Event Shares
 */
export const listEventShares = async (
  eventId: number,
  options?: RequestInit,
): Promise<listEventSharesResponseSuccess> => {
  const res = await fetch(getListEventSharesUrl(eventId), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: listEventSharesResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: listEventSharesResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? ListEventSharesResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as listEventSharesResponseSuccess;
};

export const getListEventSharesQueryKey = (eventId: number) => {
  return [`/api/v1/events/${eventId}/shares`] as const;
};

export const getListEventSharesQueryOptions = <
  TData = Awaited<ReturnType<typeof listEventShares>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventSharesQueryKey(eventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEventShares>>> = ({ signal }) =>
    listEventShares(eventId, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: eventId !== null && eventId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListEventSharesQueryResult = NonNullable<Awaited<ReturnType<typeof listEventShares>>>;
export type ListEventSharesQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useListEventShares<
  TData = Awaited<ReturnType<typeof listEventShares>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventShares>>,
          TError,
          Awaited<ReturnType<typeof listEventShares>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventShares<
  TData = Awaited<ReturnType<typeof listEventShares>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventShares>>,
          TError,
          Awaited<ReturnType<typeof listEventShares>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventShares<
  TData = Awaited<ReturnType<typeof listEventShares>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Event Shares
 */

export function useListEventShares<
  TData = Awaited<ReturnType<typeof listEventShares>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventSharesQueryOptions(eventId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListEventShares} query
 */
export const invalidateListEventShares = async (
  queryClient: QueryClient,
  eventId: number,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListEventSharesQueryKey(eventId) }, options);

  return queryClient;
};

export const getListEventSharesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listEventShares>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventSharesQueryKey(eventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEventShares>>> = ({ signal }) =>
    listEventShares(eventId, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListEventSharesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEventShares>>
>;
export type ListEventSharesSuspenseQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useListEventSharesSuspense<
  TData = Awaited<ReturnType<typeof listEventShares>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventSharesSuspense<
  TData = Awaited<ReturnType<typeof listEventShares>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEventSharesSuspense<
  TData = Awaited<ReturnType<typeof listEventShares>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Event Shares
 */

export function useListEventSharesSuspense<
  TData = Awaited<ReturnType<typeof listEventShares>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  eventId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEventShares>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventSharesSuspenseQueryOptions(eventId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateEventShareResponse200 = {
  data: UpdateEventShareResponseOutput;
  status: 200;
};

export type updateEventShareResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateEventShareResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateEventShareResponseSuccess = updateEventShareResponse200 & {
  headers: Headers;
};
export type updateEventShareResponseError = (
  | updateEventShareResponse404
  | updateEventShareResponse422
) & {
  headers: Headers;
};

export const getUpdateEventShareUrl = (eventId: number, friendGroupId: number) => {
  return `/api/v1/events/${eventId}/shares/${friendGroupId}`;
};

/**
 * Create or update an share of this event to a friend group. A share acts like an share to
 * any member of the group, including members added after the share was created. You must be
 * a participant in the event, and have a sufficient discoverable distance limit for your
 * share to be seen.
 * @summary Update Event Share
 */
export const updateEventShare = async (
  eventId: number,
  friendGroupId: number,
  updateEventShareRequest: UpdateEventShareRequest,
  options?: RequestInit,
): Promise<updateEventShareResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateEventShareUrl(eventId, friendGroupId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEventShareRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: updateEventShareResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: updateEventShareResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? UpdateEventShareResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateEventShareResponseSuccess;
};

export const getUpdateEventShareMutationKey = () => ["updateEventShare"] as const;

export const getUpdateEventShareMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventShare>>,
      TError,
      UpdateEventShareMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof updateEventShare>>,
  TError,
  UpdateEventShareMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateEventShareMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEventShare>>,
    UpdateEventShareMutationVariables
  > = (props) => {
    const { eventId, friendGroupId, data } = props ?? {};

    return updateEventShare(eventId, friendGroupId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof updateEventShare>>,
    variables: UpdateEventShareMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListEventSharesQueryKey(variables.eventId) });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type UpdateEventShareMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEventShare>>
>;
export type UpdateEventShareMutationBody = UpdateEventShareRequest;
export type UpdateEventShareMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateEventShareMutationVariables = {
  eventId: number;
  friendGroupId: number;
  data: UpdateEventShareRequest;
};

/**
 * @summary Update Event Share
 */
export const useUpdateEventShare = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventShare>>,
      TError,
      UpdateEventShareMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEventShare>>,
  TError,
  UpdateEventShareMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getUpdateEventShareMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type deleteEventShareResponse204 = {
  data: void;
  status: 204;
};

export type deleteEventShareResponseSuccess = deleteEventShareResponse204 & {
  headers: Headers;
};

export const getDeleteEventShareUrl = (eventId: number, friendGroupId: number) => {
  return `/api/v1/events/${eventId}/shares/${friendGroupId}`;
};

/**
 * Delete an share to this event. People who have already joined the event via this
 * share are not removed, but their discoverability distance may be affected.
 * @summary Delete Event Share
 */
export const deleteEventShare = async (
  eventId: number,
  friendGroupId: number,
  options?: RequestInit,
): Promise<deleteEventShareResponseSuccess> => {
  const res = await fetch(getDeleteEventShareUrl(eventId, friendGroupId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteEventShareResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as deleteEventShareResponseSuccess;
};

export const getDeleteEventShareMutationKey = () => ["deleteEventShare"] as const;

export const getDeleteEventShareMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEventShare>>,
      TError,
      DeleteEventShareMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEventShare>>,
  TError,
  DeleteEventShareMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteEventShareMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEventShare>>,
    DeleteEventShareMutationVariables
  > = (props) => {
    const { eventId, friendGroupId } = props ?? {};

    return deleteEventShare(eventId, friendGroupId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof deleteEventShare>>,
    variables: DeleteEventShareMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListEventSharesQueryKey(variables.eventId) });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type DeleteEventShareMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEventShare>>
>;

export type DeleteEventShareMutationError = globalThis.Error & { info?: unknown; status?: number };
export type DeleteEventShareMutationVariables = { eventId: number; friendGroupId: number };

/**
 * @summary Delete Event Share
 */
export const useDeleteEventShare = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEventShare>>,
      TError,
      DeleteEventShareMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEventShare>>,
  TError,
  DeleteEventShareMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getDeleteEventShareMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type updateEventWidgetLayoutResponse200 = {
  data: UpdateEventWidgetLayoutResponseOutput;
  status: 200;
};

export type updateEventWidgetLayoutResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateEventWidgetLayoutResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateEventWidgetLayoutResponseSuccess = updateEventWidgetLayoutResponse200 & {
  headers: Headers;
};
export type updateEventWidgetLayoutResponseError = (
  | updateEventWidgetLayoutResponse404
  | updateEventWidgetLayoutResponse422
) & {
  headers: Headers;
};

export const getUpdateEventWidgetLayoutUrl = (eventId: number) => {
  return `/api/v1/events/${eventId}/widgets/layout`;
};

/**
 * Save a rearrangement of an event's existing widgets. The request must include
 * every widget currently on the event (same ids), with new column/row values.
 * Does not create or delete widgets. Host only.
 * @summary Update Event Widget Layout
 */
export const updateEventWidgetLayout = async (
  eventId: number,
  updateEventWidgetLayoutRequest: UpdateEventWidgetLayoutRequest,
  options?: RequestInit,
): Promise<updateEventWidgetLayoutResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateEventWidgetLayoutUrl(eventId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEventWidgetLayoutRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: updateEventWidgetLayoutResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: updateEventWidgetLayoutResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? UpdateEventWidgetLayoutResponse.parse(parsedBody)
    : parsedBody;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as updateEventWidgetLayoutResponseSuccess;
};

export const getUpdateEventWidgetLayoutMutationKey = () => ["updateEventWidgetLayout"] as const;

export const getUpdateEventWidgetLayoutMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventWidgetLayout>>,
      TError,
      UpdateEventWidgetLayoutMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof updateEventWidgetLayout>>,
  TError,
  UpdateEventWidgetLayoutMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateEventWidgetLayoutMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEventWidgetLayout>>,
    UpdateEventWidgetLayoutMutationVariables
  > = (props) => {
    const { eventId, data } = props ?? {};

    return updateEventWidgetLayout(eventId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof updateEventWidgetLayout>>,
    variables: UpdateEventWidgetLayoutMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getGetEventQueryKey(variables.eventId) });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type UpdateEventWidgetLayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEventWidgetLayout>>
>;
export type UpdateEventWidgetLayoutMutationBody = UpdateEventWidgetLayoutRequest;
export type UpdateEventWidgetLayoutMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateEventWidgetLayoutMutationVariables = {
  eventId: number;
  data: UpdateEventWidgetLayoutRequest;
};

/**
 * @summary Update Event Widget Layout
 */
export const useUpdateEventWidgetLayout = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEventWidgetLayout>>,
      TError,
      UpdateEventWidgetLayoutMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEventWidgetLayout>>,
  TError,
  UpdateEventWidgetLayoutMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getUpdateEventWidgetLayoutMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type listFriendGroupsResponse200 = {
  data: ListFriendGroupsResponseOutput;
  status: 200;
};

export type listFriendGroupsResponseSuccess = listFriendGroupsResponse200 & {
  headers: Headers;
};

export const getListFriendGroupsUrl = () => {
  return `/api/v1/friend-groups`;
};

/**
 * List all friend groups.
 * @summary List Friend Groups
 */
export const listFriendGroups = async (
  options?: RequestInit,
): Promise<listFriendGroupsResponseSuccess> => {
  const res = await fetch(getListFriendGroupsUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeListFriendGroupsResponse(parsedBody as ListFriendGroupsResponse);
  }
  const data = contentType.includes("json")
    ? ListFriendGroupsResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as listFriendGroupsResponseSuccess;
};

const deserializeListFriendGroupsResponse = (
  data: ListFriendGroupsResponse,
): ListFriendGroupsResponse => {
  if (data == null) return data;
  if (data.friend_groups != null) {
    for (let i0 = 0; i0 < data.friend_groups.length; i0++) {
      const item0 = data.friend_groups[i0]!;
      item0.created_at = new Date(item0.created_at);
    }
  }
  return data;
};

export const getListFriendGroupsQueryKey = () => {
  return [`/api/v1/friend-groups`] as const;
};

export const getListFriendGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFriendGroups>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData>>;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFriendGroupsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFriendGroups>>> = ({ signal }) =>
    listFriendGroups({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFriendGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListFriendGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listFriendGroups>>>;
export type ListFriendGroupsQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListFriendGroups<
  TData = Awaited<ReturnType<typeof listFriendGroups>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFriendGroups>>,
          TError,
          Awaited<ReturnType<typeof listFriendGroups>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriendGroups<
  TData = Awaited<ReturnType<typeof listFriendGroups>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFriendGroups>>,
          TError,
          Awaited<ReturnType<typeof listFriendGroups>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriendGroups<
  TData = Awaited<ReturnType<typeof listFriendGroups>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Friend Groups
 */

export function useListFriendGroups<
  TData = Awaited<ReturnType<typeof listFriendGroups>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListFriendGroupsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListFriendGroups} query
 */
export const invalidateListFriendGroups = async (
  queryClient: QueryClient,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListFriendGroupsQueryKey() }, options);

  return queryClient;
};

export const getListFriendGroupsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listFriendGroups>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData>
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFriendGroupsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFriendGroups>>> = ({ signal }) =>
    listFriendGroups({ signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListFriendGroupsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFriendGroups>>
>;
export type ListFriendGroupsSuspenseQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListFriendGroupsSuspense<
  TData = Awaited<ReturnType<typeof listFriendGroups>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriendGroupsSuspense<
  TData = Awaited<ReturnType<typeof listFriendGroups>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriendGroupsSuspense<
  TData = Awaited<ReturnType<typeof listFriendGroups>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Friend Groups
 */

export function useListFriendGroupsSuspense<
  TData = Awaited<ReturnType<typeof listFriendGroups>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendGroups>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListFriendGroupsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createFriendGroupResponse200 = {
  data: CreateFriendGroupResponseOutput;
  status: 200;
};

export type createFriendGroupResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createFriendGroupResponseSuccess = createFriendGroupResponse200 & {
  headers: Headers;
};
export type createFriendGroupResponseError = createFriendGroupResponse422 & {
  headers: Headers;
};

export const getCreateFriendGroupUrl = () => {
  return `/api/v1/friend-groups`;
};

/**
 * Create a new friend group.
 * @summary Create Friend Group
 */
export const createFriendGroup = async (
  createFriendGroupRequest: CreateFriendGroupRequest,
  options?: RequestInit,
): Promise<createFriendGroupResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateFriendGroupUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createFriendGroupRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: createFriendGroupResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: createFriendGroupResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeCreateFriendGroupResponse(parsedBody as CreateFriendGroupResponse);
  }
  const data = contentType.includes("json")
    ? CreateFriendGroupResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as createFriendGroupResponseSuccess;
};

const deserializeCreateFriendGroupResponse = (
  data: CreateFriendGroupResponse,
): CreateFriendGroupResponse => {
  if (data == null) return data;
  if (data.friend_group != null) {
    data.friend_group.created_at = new Date(data.friend_group.created_at);
  }
  return data;
};

export const getCreateFriendGroupMutationKey = () => ["createFriendGroup"] as const;

export const getCreateFriendGroupMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createFriendGroup>>,
      TError,
      CreateFriendGroupMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof createFriendGroup>>,
  TError,
  CreateFriendGroupMutationVariables,
  TContext
> => {
  const mutationKey = getCreateFriendGroupMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFriendGroup>>,
    CreateFriendGroupMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createFriendGroup(data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof createFriendGroup>>,
    variables: CreateFriendGroupMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListFriendGroupsQueryKey() });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type CreateFriendGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFriendGroup>>
>;
export type CreateFriendGroupMutationBody = CreateFriendGroupRequest;
export type CreateFriendGroupMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateFriendGroupMutationVariables = { data: CreateFriendGroupRequest };

/**
 * @summary Create Friend Group
 */
export const useCreateFriendGroup = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createFriendGroup>>,
      TError,
      CreateFriendGroupMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createFriendGroup>>,
  TError,
  CreateFriendGroupMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getCreateFriendGroupMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type getFriendGroupResponse200 = {
  data: GetFriendGroupResponseOutput;
  status: 200;
};

export type getFriendGroupResponseSuccess = getFriendGroupResponse200 & {
  headers: Headers;
};

export const getGetFriendGroupUrl = (friendGroupId: number) => {
  return `/api/v1/friend-groups/${friendGroupId}`;
};

/**
 * Get one friend group and the group members.
 * @summary Get Friend Group
 */
export const getFriendGroup = async (
  friendGroupId: number,
  options?: RequestInit,
): Promise<getFriendGroupResponseSuccess> => {
  const res = await fetch(getGetFriendGroupUrl(friendGroupId), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeGetFriendGroupResponse(parsedBody as GetFriendGroupResponse);
  }
  const data = contentType.includes("json") ? GetFriendGroupResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as getFriendGroupResponseSuccess;
};

const deserializeGetFriendGroupResponse = (
  data: GetFriendGroupResponse,
): GetFriendGroupResponse => {
  if (data == null) return data;
  if (data.friend_group != null) {
    data.friend_group.created_at = new Date(data.friend_group.created_at);
  }
  if (data.members != null) {
    for (let i0 = 0; i0 < data.members.length; i0++) {
      const item0 = data.members[i0]!;
      item0.created_at = new Date(item0.created_at);
      if (item0.profile != null) {
        item0.profile.created_at = new Date(item0.profile.created_at);
      }
      if (item0.verified_at != null) {
        item0.verified_at = new Date(item0.verified_at);
      }
    }
  }
  return data;
};

export const getGetFriendGroupQueryKey = (friendGroupId: number) => {
  return [`/api/v1/friend-groups/${friendGroupId}`] as const;
};

export const getGetFriendGroupQueryOptions = <
  TData = Awaited<ReturnType<typeof getFriendGroup>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  friendGroupId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFriendGroupQueryKey(friendGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFriendGroup>>> = ({ signal }) =>
    getFriendGroup(friendGroupId, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: friendGroupId !== null && friendGroupId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetFriendGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getFriendGroup>>>;
export type GetFriendGroupQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useGetFriendGroup<
  TData = Awaited<ReturnType<typeof getFriendGroup>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  friendGroupId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFriendGroup>>,
          TError,
          Awaited<ReturnType<typeof getFriendGroup>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFriendGroup<
  TData = Awaited<ReturnType<typeof getFriendGroup>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  friendGroupId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFriendGroup>>,
          TError,
          Awaited<ReturnType<typeof getFriendGroup>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFriendGroup<
  TData = Awaited<ReturnType<typeof getFriendGroup>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  friendGroupId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Friend Group
 */

export function useGetFriendGroup<
  TData = Awaited<ReturnType<typeof getFriendGroup>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  friendGroupId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFriendGroupQueryOptions(friendGroupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useGetFriendGroup} query
 */
export const invalidateGetFriendGroup = async (
  queryClient: QueryClient,
  friendGroupId: number,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getGetFriendGroupQueryKey(friendGroupId) },
    options,
  );

  return queryClient;
};

export const getGetFriendGroupSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getFriendGroup>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  friendGroupId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFriendGroupQueryKey(friendGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFriendGroup>>> = ({ signal }) =>
    getFriendGroup(friendGroupId, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type GetFriendGroupSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFriendGroup>>
>;
export type GetFriendGroupSuspenseQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useGetFriendGroupSuspense<
  TData = Awaited<ReturnType<typeof getFriendGroup>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  friendGroupId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFriendGroupSuspense<
  TData = Awaited<ReturnType<typeof getFriendGroup>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  friendGroupId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFriendGroupSuspense<
  TData = Awaited<ReturnType<typeof getFriendGroup>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  friendGroupId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Friend Group
 */

export function useGetFriendGroupSuspense<
  TData = Awaited<ReturnType<typeof getFriendGroup>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  friendGroupId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFriendGroup>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFriendGroupSuspenseQueryOptions(friendGroupId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateFriendGroupResponse200 = {
  data: UpdateFriendGroupResponseOutput;
  status: 200;
};

export type updateFriendGroupResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateFriendGroupResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateFriendGroupResponseSuccess = updateFriendGroupResponse200 & {
  headers: Headers;
};
export type updateFriendGroupResponseError = (
  | updateFriendGroupResponse404
  | updateFriendGroupResponse422
) & {
  headers: Headers;
};

export const getUpdateFriendGroupUrl = (friendGroupId: number) => {
  return `/api/v1/friend-groups/${friendGroupId}`;
};

/**
 * Update details of this friend group.
 * @summary Update Friend Group
 */
export const updateFriendGroup = async (
  friendGroupId: number,
  updateFriendGroupRequest: UpdateFriendGroupRequest,
  options?: RequestInit,
): Promise<updateFriendGroupResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateFriendGroupUrl(friendGroupId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFriendGroupRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: updateFriendGroupResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: updateFriendGroupResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeUpdateFriendGroupResponse(parsedBody as UpdateFriendGroupResponse);
  }
  const data = contentType.includes("json")
    ? UpdateFriendGroupResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateFriendGroupResponseSuccess;
};

const deserializeUpdateFriendGroupResponse = (
  data: UpdateFriendGroupResponse,
): UpdateFriendGroupResponse => {
  if (data == null) return data;
  if (data.friend_group != null) {
    data.friend_group.created_at = new Date(data.friend_group.created_at);
  }
  return data;
};

export const getUpdateFriendGroupMutationKey = () => ["updateFriendGroup"] as const;

export const getUpdateFriendGroupMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateFriendGroup>>,
      TError,
      UpdateFriendGroupMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof updateFriendGroup>>,
  TError,
  UpdateFriendGroupMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateFriendGroupMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFriendGroup>>,
    UpdateFriendGroupMutationVariables
  > = (props) => {
    const { friendGroupId, data } = props ?? {};

    return updateFriendGroup(friendGroupId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof updateFriendGroup>>,
    variables: UpdateFriendGroupMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          [getGetFriendGroupQueryKey(variables.friendGroupId), getListFriendGroupsQueryKey()].some(
            (queryKey) => matchQuery({ queryKey }, query),
          ),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type UpdateFriendGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFriendGroup>>
>;
export type UpdateFriendGroupMutationBody = UpdateFriendGroupRequest;
export type UpdateFriendGroupMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateFriendGroupMutationVariables = {
  friendGroupId: number;
  data: UpdateFriendGroupRequest;
};

/**
 * @summary Update Friend Group
 */
export const useUpdateFriendGroup = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateFriendGroup>>,
      TError,
      UpdateFriendGroupMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateFriendGroup>>,
  TError,
  UpdateFriendGroupMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getUpdateFriendGroupMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type deleteFriendGroupResponse204 = {
  data: void;
  status: 204;
};

export type deleteFriendGroupResponseSuccess = deleteFriendGroupResponse204 & {
  headers: Headers;
};

export const getDeleteFriendGroupUrl = (friendGroupId: number) => {
  return `/api/v1/friend-groups/${friendGroupId}`;
};

/**
 * Deletes a friend group. This also deletes all event shares associated with this friend group.
 * This will not remove any friends, nor will it remove any event members who have already joined
 * as a result of a share to this group.
 * @summary Delete Friend Group
 */
export const deleteFriendGroup = async (
  friendGroupId: number,
  options?: RequestInit,
): Promise<deleteFriendGroupResponseSuccess> => {
  const res = await fetch(getDeleteFriendGroupUrl(friendGroupId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteFriendGroupResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as deleteFriendGroupResponseSuccess;
};

export const getDeleteFriendGroupMutationKey = () => ["deleteFriendGroup"] as const;

export const getDeleteFriendGroupMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFriendGroup>>,
      TError,
      DeleteFriendGroupMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFriendGroup>>,
  TError,
  DeleteFriendGroupMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteFriendGroupMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFriendGroup>>,
    DeleteFriendGroupMutationVariables
  > = (props) => {
    const { friendGroupId } = props ?? {};

    return deleteFriendGroup(friendGroupId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof deleteFriendGroup>>,
    variables: DeleteFriendGroupMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListFriendGroupsQueryKey() });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type DeleteFriendGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFriendGroup>>
>;

export type DeleteFriendGroupMutationError = globalThis.Error & { info?: unknown; status?: number };
export type DeleteFriendGroupMutationVariables = { friendGroupId: number };

/**
 * @summary Delete Friend Group
 */
export const useDeleteFriendGroup = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFriendGroup>>,
      TError,
      DeleteFriendGroupMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFriendGroup>>,
  TError,
  DeleteFriendGroupMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getDeleteFriendGroupMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type addFriendGroupMemberResponse200 = {
  data: AddFriendGroupMemberResponseOutput;
  status: 200;
};

export type addFriendGroupMemberResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type addFriendGroupMemberResponse409 = {
  data: ErrorDetailResponse;
  status: 409;
};

export type addFriendGroupMemberResponseSuccess = addFriendGroupMemberResponse200 & {
  headers: Headers;
};
export type addFriendGroupMemberResponseError = (
  | addFriendGroupMemberResponse404
  | addFriendGroupMemberResponse409
) & {
  headers: Headers;
};

export const getAddFriendGroupMemberUrl = (friendGroupId: number) => {
  return `/api/v1/friend-groups/${friendGroupId}/add-member`;
};

/**
 * Add a friend to a friend group. Friends may be part of multiple friend groups simultaneously.
 * @summary Add Friend Group Member
 */
export const addFriendGroupMember = async (
  friendGroupId: number,
  addFriendGroupMemberRequest: AddFriendGroupMemberRequest,
  options?: RequestInit,
): Promise<addFriendGroupMemberResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getAddFriendGroupMemberUrl(friendGroupId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(addFriendGroupMemberRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: addFriendGroupMemberResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: addFriendGroupMemberResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeAddFriendGroupMemberResponse(
      parsedBody as AddFriendGroupMemberResponse,
    );
  }
  const data = contentType.includes("json")
    ? AddFriendGroupMemberResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as addFriendGroupMemberResponseSuccess;
};

const deserializeAddFriendGroupMemberResponse = (
  data: AddFriendGroupMemberResponse,
): AddFriendGroupMemberResponse => {
  if (data == null) return data;
  if (data.friend_group != null) {
    data.friend_group.created_at = new Date(data.friend_group.created_at);
  }
  return data;
};

export const getAddFriendGroupMemberMutationKey = () => ["addFriendGroupMember"] as const;

export const getAddFriendGroupMemberMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addFriendGroupMember>>,
      TError,
      AddFriendGroupMemberMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof addFriendGroupMember>>,
  TError,
  AddFriendGroupMemberMutationVariables,
  TContext
> => {
  const mutationKey = getAddFriendGroupMemberMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addFriendGroupMember>>,
    AddFriendGroupMemberMutationVariables
  > = (props) => {
    const { friendGroupId, data } = props ?? {};

    return addFriendGroupMember(friendGroupId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof addFriendGroupMember>>,
    variables: AddFriendGroupMemberMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        queryKey: getGetFriendGroupQueryKey(variables.friendGroupId),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type AddFriendGroupMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof addFriendGroupMember>>
>;
export type AddFriendGroupMemberMutationBody = AddFriendGroupMemberRequest;
export type AddFriendGroupMemberMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type AddFriendGroupMemberMutationVariables = {
  friendGroupId: number;
  data: AddFriendGroupMemberRequest;
};

/**
 * @summary Add Friend Group Member
 */
export const useAddFriendGroupMember = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addFriendGroupMember>>,
      TError,
      AddFriendGroupMemberMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addFriendGroupMember>>,
  TError,
  AddFriendGroupMemberMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getAddFriendGroupMemberMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type removeFriendGroupMemberResponse204 = {
  data: void;
  status: 204;
};

export type removeFriendGroupMemberResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type removeFriendGroupMemberResponseSuccess = removeFriendGroupMemberResponse204 & {
  headers: Headers;
};
export type removeFriendGroupMemberResponseError = removeFriendGroupMemberResponse404 & {
  headers: Headers;
};

export const getRemoveFriendGroupMemberUrl = (friendGroupId: number) => {
  return `/api/v1/friend-groups/${friendGroupId}/remove-member`;
};

/**
 * Remove a friend from a friend group. They are still your friend though.
 * @summary Remove Friend Group Member
 */
export const removeFriendGroupMember = async (
  friendGroupId: number,
  removeFriendGroupMemberRequest: RemoveFriendGroupMemberRequest,
  options?: RequestInit,
): Promise<removeFriendGroupMemberResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getRemoveFriendGroupMemberUrl(friendGroupId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(removeFriendGroupMemberRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: removeFriendGroupMemberResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: removeFriendGroupMemberResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: removeFriendGroupMemberResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as removeFriendGroupMemberResponseSuccess;
};

export const getRemoveFriendGroupMemberMutationKey = () => ["removeFriendGroupMember"] as const;

export const getRemoveFriendGroupMemberMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeFriendGroupMember>>,
      TError,
      RemoveFriendGroupMemberMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof removeFriendGroupMember>>,
  TError,
  RemoveFriendGroupMemberMutationVariables,
  TContext
> => {
  const mutationKey = getRemoveFriendGroupMemberMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFriendGroupMember>>,
    RemoveFriendGroupMemberMutationVariables
  > = (props) => {
    const { friendGroupId, data } = props ?? {};

    return removeFriendGroupMember(friendGroupId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof removeFriendGroupMember>>,
    variables: RemoveFriendGroupMemberMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        queryKey: getGetFriendGroupQueryKey(variables.friendGroupId),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type RemoveFriendGroupMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeFriendGroupMember>>
>;
export type RemoveFriendGroupMemberMutationBody = RemoveFriendGroupMemberRequest;
export type RemoveFriendGroupMemberMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type RemoveFriendGroupMemberMutationVariables = {
  friendGroupId: number;
  data: RemoveFriendGroupMemberRequest;
};

/**
 * @summary Remove Friend Group Member
 */
export const useRemoveFriendGroupMember = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeFriendGroupMember>>,
      TError,
      RemoveFriendGroupMemberMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeFriendGroupMember>>,
  TError,
  RemoveFriendGroupMemberMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getRemoveFriendGroupMemberMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type listFriendRequestsResponse200 = {
  data: ListFriendRequestsResponseOutput;
  status: 200;
};

export type listFriendRequestsResponseSuccess = listFriendRequestsResponse200 & {
  headers: Headers;
};

export const getListFriendRequestsUrl = () => {
  return `/api/v1/friend-requests`;
};

/**
 * List pending sent and received friend requests.
 * @summary List Friend Requests
 */
export const listFriendRequests = async (
  options?: RequestInit,
): Promise<listFriendRequestsResponseSuccess> => {
  const res = await fetch(getListFriendRequestsUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeListFriendRequestsResponse(parsedBody as ListFriendRequestsResponse);
  }
  const data = contentType.includes("json")
    ? ListFriendRequestsResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as listFriendRequestsResponseSuccess;
};

const deserializeListFriendRequestsResponse = (
  data: ListFriendRequestsResponse,
): ListFriendRequestsResponse => {
  if (data == null) return data;
  if (data.received_friend_requests != null) {
    for (let i0 = 0; i0 < data.received_friend_requests.length; i0++) {
      const item0 = data.received_friend_requests[i0]!;
      item0.created_at = new Date(item0.created_at);
      if (item0.profile != null) {
        item0.profile.created_at = new Date(item0.profile.created_at);
      }
    }
  }
  if (data.sent_friend_requests != null) {
    for (let i0 = 0; i0 < data.sent_friend_requests.length; i0++) {
      const item0 = data.sent_friend_requests[i0]!;
      item0.created_at = new Date(item0.created_at);
      if (item0.profile != null) {
        item0.profile.created_at = new Date(item0.profile.created_at);
      }
    }
  }
  return data;
};

export const getListFriendRequestsQueryKey = () => {
  return [`/api/v1/friend-requests`] as const;
};

export const getListFriendRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFriendRequests>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData>>;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFriendRequestsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFriendRequests>>> = ({ signal }) =>
    listFriendRequests({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFriendRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListFriendRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFriendRequests>>
>;
export type ListFriendRequestsQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListFriendRequests<
  TData = Awaited<ReturnType<typeof listFriendRequests>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFriendRequests>>,
          TError,
          Awaited<ReturnType<typeof listFriendRequests>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriendRequests<
  TData = Awaited<ReturnType<typeof listFriendRequests>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFriendRequests>>,
          TError,
          Awaited<ReturnType<typeof listFriendRequests>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriendRequests<
  TData = Awaited<ReturnType<typeof listFriendRequests>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Friend Requests
 */

export function useListFriendRequests<
  TData = Awaited<ReturnType<typeof listFriendRequests>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListFriendRequestsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListFriendRequests} query
 */
export const invalidateListFriendRequests = async (
  queryClient: QueryClient,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListFriendRequestsQueryKey() }, options);

  return queryClient;
};

export const getListFriendRequestsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listFriendRequests>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData>
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFriendRequestsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFriendRequests>>> = ({ signal }) =>
    listFriendRequests({ signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListFriendRequestsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFriendRequests>>
>;
export type ListFriendRequestsSuspenseQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListFriendRequestsSuspense<
  TData = Awaited<ReturnType<typeof listFriendRequests>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriendRequestsSuspense<
  TData = Awaited<ReturnType<typeof listFriendRequests>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFriendRequestsSuspense<
  TData = Awaited<ReturnType<typeof listFriendRequests>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Friend Requests
 */

export function useListFriendRequestsSuspense<
  TData = Awaited<ReturnType<typeof listFriendRequests>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFriendRequests>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListFriendRequestsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createFriendRequestResponse200 = {
  data: CreateFriendRequestResponseOutput;
  status: 200;
};

export type createFriendRequestResponse201 = {
  data: CreateFriendRequestResponseOutput;
  status: 201;
};

export type createFriendRequestResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type createFriendRequestResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type createFriendRequestResponseSuccess = (
  | createFriendRequestResponse200
  | createFriendRequestResponse201
) & {
  headers: Headers;
};
export type createFriendRequestResponseError = (
  | createFriendRequestResponse404
  | createFriendRequestResponse422
) & {
  headers: Headers;
};

export const getCreateFriendRequestUrl = () => {
  return `/api/v1/friend-requests`;
};

/**
 * Send (or respond to) a friend request. Accept a friend request by sending one back.
 * @summary Send/Accept Friend Request
 */
export const createFriendRequest = async (
  createFriendRequestRequest: CreateFriendRequestRequest,
  options?: RequestInit,
): Promise<createFriendRequestResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreateFriendRequestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createFriendRequestRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: createFriendRequestResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: createFriendRequestResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  const data = contentType.includes("json")
    ? CreateFriendRequestResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as createFriendRequestResponseSuccess;
};

export const getCreateFriendRequestMutationKey = () => ["createFriendRequest"] as const;

export const getCreateFriendRequestMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createFriendRequest>>,
      TError,
      CreateFriendRequestMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof createFriendRequest>>,
  TError,
  CreateFriendRequestMutationVariables,
  TContext
> => {
  const mutationKey = getCreateFriendRequestMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFriendRequest>>,
    CreateFriendRequestMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createFriendRequest(data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof createFriendRequest>>,
    variables: CreateFriendRequestMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          [getListFriendRequestsQueryKey(), getListFriendsQueryKey("@me")].some((queryKey) =>
            matchQuery({ queryKey }, query),
          ),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type CreateFriendRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFriendRequest>>
>;
export type CreateFriendRequestMutationBody = CreateFriendRequestRequest;
export type CreateFriendRequestMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type CreateFriendRequestMutationVariables = { data: CreateFriendRequestRequest };

/**
 * @summary Send/Accept Friend Request
 */
export const useCreateFriendRequest = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createFriendRequest>>,
      TError,
      CreateFriendRequestMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createFriendRequest>>,
  TError,
  CreateFriendRequestMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getCreateFriendRequestMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type dismissFriendRequestResponse204 = {
  data: void;
  status: 204;
};

export type dismissFriendRequestResponseSuccess = dismissFriendRequestResponse204 & {
  headers: Headers;
};

export const getDismissFriendRequestUrl = () => {
  return `/api/v1/friend-requests/dismiss`;
};

/**
 * Dismiss (or retract) a friend request. The friend request may always be sent again by either person.
 * @summary Dismiss/Cancel Friend Request
 */
export const dismissFriendRequest = async (
  dismissFriendRequestRequest: DismissFriendRequestRequest,
  options?: RequestInit,
): Promise<dismissFriendRequestResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getDismissFriendRequestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(dismissFriendRequestRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: dismissFriendRequestResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as dismissFriendRequestResponseSuccess;
};

export const getDismissFriendRequestMutationKey = () => ["dismissFriendRequest"] as const;

export const getDismissFriendRequestMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof dismissFriendRequest>>,
      TError,
      DismissFriendRequestMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof dismissFriendRequest>>,
  TError,
  DismissFriendRequestMutationVariables,
  TContext
> => {
  const mutationKey = getDismissFriendRequestMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissFriendRequest>>,
    DismissFriendRequestMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return dismissFriendRequest(data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof dismissFriendRequest>>,
    variables: DismissFriendRequestMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListFriendRequestsQueryKey() });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type DismissFriendRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissFriendRequest>>
>;
export type DismissFriendRequestMutationBody = DismissFriendRequestRequest;
export type DismissFriendRequestMutationError = globalThis.Error & {
  info?: unknown;
  status?: number;
};
export type DismissFriendRequestMutationVariables = { data: DismissFriendRequestRequest };

/**
 * @summary Dismiss/Cancel Friend Request
 */
export const useDismissFriendRequest = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof dismissFriendRequest>>,
      TError,
      DismissFriendRequestMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof dismissFriendRequest>>,
  TError,
  DismissFriendRequestMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getDismissFriendRequestMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type updateFriendResponse200 = {
  data: UpdateFriendResponseOutput;
  status: 200;
};

export type updateFriendResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type updateFriendResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updateFriendResponseSuccess = updateFriendResponse200 & {
  headers: Headers;
};
export type updateFriendResponseError = (updateFriendResponse404 | updateFriendResponse422) & {
  headers: Headers;
};

export const getUpdateFriendUrl = (friendId: string) => {
  return `/api/v1/friends/${friendId}`;
};

/**
 * Update details of this friendship.
 * @summary Update Friend
 */
export const updateFriend = async (
  friendId: string,
  updateFriendRequest: UpdateFriendRequest,
  options?: RequestInit,
): Promise<updateFriendResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateFriendUrl(friendId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFriendRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: updateFriendResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: updateFriendResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeUpdateFriendResponse(parsedBody as UpdateFriendResponse);
  }
  const data = contentType.includes("json") ? UpdateFriendResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateFriendResponseSuccess;
};

const deserializeUpdateFriendResponse = (data: UpdateFriendResponse): UpdateFriendResponse => {
  if (data == null) return data;
  if (data.friend != null) {
    data.friend.created_at = new Date(data.friend.created_at);
    if (data.friend.profile != null) {
      data.friend.profile.created_at = new Date(data.friend.profile.created_at);
    }
    if (data.friend.verified_at != null) {
      data.friend.verified_at = new Date(data.friend.verified_at);
    }
  }
  return data;
};

export const getUpdateFriendMutationKey = () => ["updateFriend"] as const;

export const getUpdateFriendMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateFriend>>,
      TError,
      UpdateFriendMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof updateFriend>>,
  TError,
  UpdateFriendMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateFriendMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFriend>>,
    UpdateFriendMutationVariables
  > = (props) => {
    const { friendId, data } = props ?? {};

    return updateFriend(friendId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof updateFriend>>,
    variables: UpdateFriendMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListFriendsQueryKey("@me") });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type UpdateFriendMutationResult = NonNullable<Awaited<ReturnType<typeof updateFriend>>>;
export type UpdateFriendMutationBody = UpdateFriendRequest;
export type UpdateFriendMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdateFriendMutationVariables = { friendId: string; data: UpdateFriendRequest };

/**
 * @summary Update Friend
 */
export const useUpdateFriend = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateFriend>>,
      TError,
      UpdateFriendMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateFriend>>,
  TError,
  UpdateFriendMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getUpdateFriendMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type removeFriendResponse204 = {
  data: void;
  status: 204;
};

export type removeFriendResponseSuccess = removeFriendResponse204 & {
  headers: Headers;
};

export const getRemoveFriendUrl = (friendId: string) => {
  return `/api/v1/friends/${friendId}`;
};

/**
 * Remove a friend from your friend list. This also removes yourself from their friend list.
 * You (or they) will still be able to re-request this friendship.
 * @summary Remove Friend
 */
export const removeFriend = async (
  friendId: string,
  options?: RequestInit,
): Promise<removeFriendResponseSuccess> => {
  const res = await fetch(getRemoveFriendUrl(friendId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: removeFriendResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as removeFriendResponseSuccess;
};

export const getRemoveFriendMutationKey = () => ["removeFriend"] as const;

export const getRemoveFriendMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeFriend>>,
      TError,
      RemoveFriendMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof removeFriend>>,
  TError,
  RemoveFriendMutationVariables,
  TContext
> => {
  const mutationKey = getRemoveFriendMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFriend>>,
    RemoveFriendMutationVariables
  > = (props) => {
    const { friendId } = props ?? {};

    return removeFriend(friendId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof removeFriend>>,
    variables: RemoveFriendMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          [getListFriendsQueryKey("@me")].some((queryKey) => matchQuery({ queryKey }, query)) ||
          (typeof query.queryKey[0] === "string" &&
            query.queryKey[0].startsWith("/api/v1/friend-groups/")),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type RemoveFriendMutationResult = NonNullable<Awaited<ReturnType<typeof removeFriend>>>;

export type RemoveFriendMutationError = globalThis.Error & { info?: unknown; status?: number };
export type RemoveFriendMutationVariables = { friendId: string };

/**
 * @summary Remove Friend
 */
export const useRemoveFriend = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeFriend>>,
      TError,
      RemoveFriendMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeFriend>>,
  TError,
  RemoveFriendMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getRemoveFriendMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type deleteEventInviteCodeResponse204 = {
  data: void;
  status: 204;
};

export type deleteEventInviteCodeResponseSuccess = deleteEventInviteCodeResponse204 & {
  headers: Headers;
};

export const getDeleteEventInviteCodeUrl = (inviteCodeId: string) => {
  return `/api/v1/invite-codes/${inviteCodeId}`;
};

/**
 * Delete an invite code. Users who already used this link and signed up will keep access, but
 * the link will no longer reach the event for anyone else.
 * @summary Delete Event Invite Code
 */
export const deleteEventInviteCode = async (
  inviteCodeId: string,
  options?: RequestInit,
): Promise<deleteEventInviteCodeResponseSuccess> => {
  const res = await fetch(getDeleteEventInviteCodeUrl(inviteCodeId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteEventInviteCodeResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as deleteEventInviteCodeResponseSuccess;
};

export const getDeleteEventInviteCodeMutationKey = () => ["deleteEventInviteCode"] as const;

export const getDeleteEventInviteCodeMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEventInviteCode>>,
      TError,
      DeleteEventInviteCodeMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEventInviteCode>>,
  TError,
  DeleteEventInviteCodeMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteEventInviteCodeMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEventInviteCode>>,
    DeleteEventInviteCodeMutationVariables
  > = (props) => {
    const { inviteCodeId } = props ?? {};

    return deleteEventInviteCode(inviteCodeId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof deleteEventInviteCode>>,
    variables: DeleteEventInviteCodeMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" && query.queryKey[0].startsWith("/api/v1/events/"),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type DeleteEventInviteCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEventInviteCode>>
>;

export type DeleteEventInviteCodeMutationError = globalThis.Error & {
  info?: unknown;
  status?: number;
};
export type DeleteEventInviteCodeMutationVariables = { inviteCodeId: string };

/**
 * @summary Delete Event Invite Code
 */
export const useDeleteEventInviteCode = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEventInviteCode>>,
      TError,
      DeleteEventInviteCodeMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEventInviteCode>>,
  TError,
  DeleteEventInviteCodeMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getDeleteEventInviteCodeMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type listNotificationsResponse200 = {
  data: ListNotificationsResponseOutput;
  status: 200;
};

export type listNotificationsResponseSuccess = listNotificationsResponse200 & {
  headers: Headers;
};

export const getListNotificationsUrl = (params: ListNotificationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/notifications?${stringifiedParams}`
    : `/api/v1/notifications`;
};

/**
 * List notifications sent to the authorized account. This includes all in-app notifications that
 * are sent, whether they are pushed to devices or not.
 *
 * This is a paginated API. Responses are returned in order of `start_time`.
 * @summary List Notifications
 */
export const listNotifications = async (
  params: ListNotificationsParams,
  options?: RequestInit,
): Promise<listNotificationsResponseSuccess> => {
  const res = await fetch(getListNotificationsUrl(params), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeListNotificationsResponse(parsedBody as ListNotificationsResponse);
  }
  const data = contentType.includes("json")
    ? ListNotificationsResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as listNotificationsResponseSuccess;
};

const deserializeListNotificationsResponse = (
  data: ListNotificationsResponse,
): ListNotificationsResponse => {
  if (data == null) return data;
  if (data.notifications != null) {
    for (let i0 = 0; i0 < data.notifications.length; i0++) {
      const item0 = data.notifications[i0]!;
      if (item0.acknowledged_at != null) {
        item0.acknowledged_at = new Date(item0.acknowledged_at);
      }
      item0.created_at = new Date(item0.created_at);
    }
  }
  return data;
};

export const getListNotificationsInfiniteQueryKey = (params?: ListNotificationsParams) => {
  return ["infinite", `/api/v1/notifications`, ...(params ? [params] : [])] as const;
};

export const getListNotificationsQueryKey = (params?: ListNotificationsParams) => {
  return [`/api/v1/notifications`, ...(params ? [params] : [])] as const;
};

export const getListNotificationsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listNotifications>>,
    ListNotificationsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listNotifications>>,
        TError,
        TData,
        QueryKey,
        ListNotificationsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotificationsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNotifications>>,
    QueryKey,
    ListNotificationsParams["after_cursor"]
  > = ({ signal, pageParam }) =>
    listNotifications(
      { ...params, after_cursor: pageParam ?? params?.["after_cursor"] },
      { signal, ...fetchOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData,
    QueryKey,
    ListNotificationsParams["after_cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListNotificationsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type ListNotificationsInfiniteQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListNotificationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listNotifications>>,
    ListNotificationsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listNotifications>>,
        TError,
        TData,
        QueryKey,
        ListNotificationsParams["after_cursor"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>,
          QueryKey
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotificationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listNotifications>>,
    ListNotificationsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listNotifications>>,
        TError,
        TData,
        QueryKey,
        ListNotificationsParams["after_cursor"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>,
          QueryKey
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotificationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listNotifications>>,
    ListNotificationsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listNotifications>>,
        TError,
        TData,
        QueryKey,
        ListNotificationsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Notifications
 */

export function useListNotificationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listNotifications>>,
    ListNotificationsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listNotifications>>,
        TError,
        TData,
        QueryKey,
        ListNotificationsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListNotificationsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListNotificationsInfinite} query
 */
export const invalidateListNotificationsInfinite = async (
  queryClient: QueryClient,
  params: ListNotificationsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getListNotificationsInfiniteQueryKey(params) },
    options,
  );

  return queryClient;
};

export const getListNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotificationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) =>
    listNotifications(params, { signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type ListNotificationsQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Notifications
 */

export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListNotifications} query
 */
export const invalidateListNotifications = async (
  queryClient: QueryClient,
  params: ListNotificationsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListNotificationsQueryKey(params) }, options);

  return queryClient;
};

export const getListNotificationsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotificationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) =>
    listNotifications(params, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListNotificationsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type ListNotificationsSuspenseQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListNotificationsSuspense<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotificationsSuspense<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotificationsSuspense<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Notifications
 */

export function useListNotificationsSuspense<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListNotificationsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListNotificationsSuspenseInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listNotifications>>,
    ListNotificationsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listNotifications>>,
        TError,
        TData,
        QueryKey,
        ListNotificationsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotificationsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNotifications>>,
    QueryKey,
    ListNotificationsParams["after_cursor"]
  > = ({ signal, pageParam }) =>
    listNotifications(
      { ...params, after_cursor: pageParam ?? params?.["after_cursor"] },
      { signal, ...fetchOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData,
    QueryKey,
    ListNotificationsParams["after_cursor"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListNotificationsSuspenseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type ListNotificationsSuspenseInfiniteQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useListNotificationsSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listNotifications>>,
    ListNotificationsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options: {
    query: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listNotifications>>,
        TError,
        TData,
        QueryKey,
        ListNotificationsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotificationsSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listNotifications>>,
    ListNotificationsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listNotifications>>,
        TError,
        TData,
        QueryKey,
        ListNotificationsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotificationsSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listNotifications>>,
    ListNotificationsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listNotifications>>,
        TError,
        TData,
        QueryKey,
        ListNotificationsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Notifications
 */

export function useListNotificationsSuspenseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listNotifications>>,
    ListNotificationsParams["after_cursor"]
  >,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: ListNotificationsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listNotifications>>,
        TError,
        TData,
        QueryKey,
        ListNotificationsParams["after_cursor"]
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListNotificationsSuspenseInfiniteQueryOptions(params, options);

  const query = useSuspenseInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type subscribeNotificationsResponse200 = {
  data: void;
  status: 200;
};

export type subscribeNotificationsResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type subscribeNotificationsResponseSuccess = subscribeNotificationsResponse200 & {
  headers: Headers;
};
export type subscribeNotificationsResponseError = subscribeNotificationsResponse422 & {
  headers: Headers;
};

export const getSubscribeNotificationsUrl = () => {
  return `/api/v1/notifications/subscribe`;
};

/**
 * Subscribe the current session/device/user for push notifications.
 * @summary Subscribe for Push Notifications
 */
export const subscribeNotifications = async (
  subscribeNotificationsRequest: SubscribeNotificationsRequest,
  options?: RequestInit,
): Promise<subscribeNotificationsResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getSubscribeNotificationsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(subscribeNotificationsRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: subscribeNotificationsResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: subscribeNotificationsResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: subscribeNotificationsResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as subscribeNotificationsResponseSuccess;
};

export const getSubscribeNotificationsMutationKey = () => ["subscribeNotifications"] as const;

export const getSubscribeNotificationsMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribeNotifications>>,
    TError,
    SubscribeNotificationsMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof subscribeNotifications>>,
  TError,
  SubscribeNotificationsMutationVariables,
  TContext
> => {
  const mutationKey = getSubscribeNotificationsMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof subscribeNotifications>>,
    SubscribeNotificationsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return subscribeNotifications(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubscribeNotificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof subscribeNotifications>>
>;
export type SubscribeNotificationsMutationBody = SubscribeNotificationsRequest;
export type SubscribeNotificationsMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type SubscribeNotificationsMutationVariables = { data: SubscribeNotificationsRequest };

/**
 * @summary Subscribe for Push Notifications
 */
export const useSubscribeNotifications = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof subscribeNotifications>>,
      TError,
      SubscribeNotificationsMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof subscribeNotifications>>,
  TError,
  SubscribeNotificationsMutationVariables,
  TContext
> => {
  return useMutation(getSubscribeNotificationsMutationOptions(options), queryClient);
};

export type updateNotificationResponse200 = {
  data: UpdateNotificationResponseOutput;
  status: 200;
};

export type updateNotificationResponse404 = {
  data: UpdateNotificationResponse;
  status: 404;
};

export type updateNotificationResponseSuccess = updateNotificationResponse200 & {
  headers: Headers;
};
export type updateNotificationResponseError = updateNotificationResponse404 & {
  headers: Headers;
};

export const getUpdateNotificationUrl = (notificationId: number) => {
  return `/api/v1/notifications/${notificationId}`;
};

/**
 * Update a notification; basically just for marking as read/unread.
 * @summary Update Notification
 */
export const updateNotification = async (
  notificationId: number,
  updateNotificationRequest: UpdateNotificationRequest,
  options?: RequestInit,
): Promise<updateNotificationResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdateNotificationUrl(notificationId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updateNotificationRequest),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: updateNotificationResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: updateNotificationResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeUpdateNotificationResponse(parsedBody as UpdateNotificationResponse);
  }
  const data = contentType.includes("json")
    ? UpdateNotificationResponse.parse(parsedBody)
    : parsedBody;
  return { data, status: res.status, headers: res.headers } as updateNotificationResponseSuccess;
};

const deserializeUpdateNotificationResponse = (
  data: UpdateNotificationResponse,
): UpdateNotificationResponse => {
  if (data == null) return data;
  if (data.notification != null) {
    if (data.notification.acknowledged_at != null) {
      data.notification.acknowledged_at = new Date(data.notification.acknowledged_at);
    }
    data.notification.created_at = new Date(data.notification.created_at);
  }
  return data;
};

export const getUpdateNotificationMutationKey = () => ["updateNotification"] as const;

export const getUpdateNotificationMutationOptions = <
  TError = globalThis.Error & { info?: UpdateNotificationResponse; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateNotification>>,
      TError,
      UpdateNotificationMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotification>>,
  TError,
  UpdateNotificationMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateNotificationMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotification>>,
    UpdateNotificationMutationVariables
  > = (props) => {
    const { notificationId, data } = props ?? {};

    return updateNotification(notificationId, data, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof updateNotification>>,
    variables: UpdateNotificationMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.resetQueries({
        predicate: (query) =>
          [getListNotificationsQueryKey(), getListNotificationsInfiniteQueryKey()].some(
            (queryKey) => matchQuery({ queryKey }, query),
          ),
      });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type UpdateNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotification>>
>;
export type UpdateNotificationMutationBody = UpdateNotificationRequest;
export type UpdateNotificationMutationError = globalThis.Error & {
  info?: UpdateNotificationResponse;
  status?: number;
};
export type UpdateNotificationMutationVariables = {
  notificationId: number;
  data: UpdateNotificationRequest;
};

/**
 * @summary Update Notification
 */
export const useUpdateNotification = <
  TError = globalThis.Error & { info?: UpdateNotificationResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateNotification>>,
      TError,
      UpdateNotificationMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateNotification>>,
  TError,
  UpdateNotificationMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getUpdateNotificationMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};

export type updatePasswordResponse204 = {
  data: void;
  status: 204;
};

export type updatePasswordResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type updatePasswordResponseSuccess = updatePasswordResponse204 & {
  headers: Headers;
};
export type updatePasswordResponseError = updatePasswordResponse422 & {
  headers: Headers;
};

export const getUpdatePasswordUrl = () => {
  return `/api/v1/password`;
};

/**
 * Change the password of the account.
 * @summary Update Password.
 */
export const updatePassword = async (
  updatePasswordRequest: UpdatePasswordRequest,
  options?: RequestInit,
): Promise<updatePasswordResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getUpdatePasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePasswordRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: updatePasswordResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: updatePasswordResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: updatePasswordResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as updatePasswordResponseSuccess;
};

export const getUpdatePasswordMutationKey = () => ["updatePassword"] as const;

export const getUpdatePasswordMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePassword>>,
    TError,
    UpdatePasswordMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePassword>>,
  TError,
  UpdatePasswordMutationVariables,
  TContext
> => {
  const mutationKey = getUpdatePasswordMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePassword>>,
    UpdatePasswordMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updatePassword(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof updatePassword>>>;
export type UpdatePasswordMutationBody = UpdatePasswordRequest;
export type UpdatePasswordMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type UpdatePasswordMutationVariables = { data: UpdatePasswordRequest };

/**
 * @summary Update Password.
 */
export const useUpdatePassword = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePassword>>,
      TError,
      UpdatePasswordMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePassword>>,
  TError,
  UpdatePasswordMutationVariables,
  TContext
> => {
  return useMutation(getUpdatePasswordMutationOptions(options), queryClient);
};

export type createPasswordResetRequestResponse204 = {
  data: void;
  status: 204;
};

export type createPasswordResetRequestResponseSuccess = createPasswordResetRequestResponse204 & {
  headers: Headers;
};

export const getCreatePasswordResetRequestUrl = () => {
  return `/api/v1/password-reset/request`;
};

/**
 * Requests a reset password link. The link will be sent to the account's primary email,
 * if there is one. There is no indication whether the request was successful or not to
 * the caller, to avoid scraping.
 *
 * Only 3 active reset password requests may exist for one account; further submissions
 * will not go through until some start to expire.
 * @summary Request Password Reset
 */
export const createPasswordResetRequest = async (
  createPasswordResetRequestRequest: CreatePasswordResetRequestRequest,
  options?: RequestInit,
): Promise<createPasswordResetRequestResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getCreatePasswordResetRequestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(createPasswordResetRequestRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: createPasswordResetRequestResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createPasswordResetRequestResponseSuccess;
};

export const getCreatePasswordResetRequestMutationKey = () =>
  ["createPasswordResetRequest"] as const;

export const getCreatePasswordResetRequestMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPasswordResetRequest>>,
    TError,
    CreatePasswordResetRequestMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPasswordResetRequest>>,
  TError,
  CreatePasswordResetRequestMutationVariables,
  TContext
> => {
  const mutationKey = getCreatePasswordResetRequestMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPasswordResetRequest>>,
    CreatePasswordResetRequestMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createPasswordResetRequest(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePasswordResetRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPasswordResetRequest>>
>;
export type CreatePasswordResetRequestMutationBody = CreatePasswordResetRequestRequest;
export type CreatePasswordResetRequestMutationError = globalThis.Error & {
  info?: unknown;
  status?: number;
};
export type CreatePasswordResetRequestMutationVariables = {
  data: CreatePasswordResetRequestRequest;
};

/**
 * @summary Request Password Reset
 */
export const useCreatePasswordResetRequest = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPasswordResetRequest>>,
      TError,
      CreatePasswordResetRequestMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPasswordResetRequest>>,
  TError,
  CreatePasswordResetRequestMutationVariables,
  TContext
> => {
  return useMutation(getCreatePasswordResetRequestMutationOptions(options), queryClient);
};

export type resetPasswordResponse204 = {
  data: void;
  status: 204;
};

export type resetPasswordResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type resetPasswordResponse422 = {
  data: ErrorDetailResponse;
  status: 422;
};

export type resetPasswordResponseSuccess = resetPasswordResponse204 & {
  headers: Headers;
};
export type resetPasswordResponseError = (resetPasswordResponse404 | resetPasswordResponse422) & {
  headers: Headers;
};

export const getResetPasswordUrl = (resetId: string) => {
  return `/api/v1/password-reset/${resetId}`;
};

/**
 * Change the password of the account from a password reset request.
 * @summary Reset Password
 */
export const resetPassword = async (
  resetId: string,
  resetPasswordRequest: ResetPasswordRequest,
  options?: RequestInit,
): Promise<resetPasswordResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  const res = await fetch(getResetPasswordUrl(resetId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(resetPasswordRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: resetPasswordResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: resetPasswordResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: resetPasswordResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as resetPasswordResponseSuccess;
};

export const getResetPasswordMutationKey = () => ["resetPassword"] as const;

export const getResetPasswordMutationOptions = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    ResetPasswordMutationVariables,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  ResetPasswordMutationVariables,
  TContext
> => {
  const mutationKey = getResetPasswordMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPassword>>,
    ResetPasswordMutationVariables
  > = (props) => {
    const { resetId, data } = props ?? {};

    return resetPassword(resetId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>;
export type ResetPasswordMutationBody = ResetPasswordRequest;
export type ResetPasswordMutationError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};
export type ResetPasswordMutationVariables = { resetId: string; data: ResetPasswordRequest };

/**
 * @summary Reset Password
 */
export const useResetPassword = <
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetPassword>>,
      TError,
      ResetPasswordMutationVariables,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  ResetPasswordMutationVariables,
  TContext
> => {
  return useMutation(getResetPasswordMutationOptions(options), queryClient);
};

export type searchProfilesResponse200 = {
  data: SearchProfilesResponseOutput;
  status: 200;
};

export type searchProfilesResponseSuccess = searchProfilesResponse200 & {
  headers: Headers;
};

export const getSearchProfilesUrl = (params: SearchProfilesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/profiles/search?${stringifiedParams}`
    : `/api/v1/profiles/search`;
};

/**
 * Search all profiles using a single query. For now, the logic is just "id starts with".
 * @summary Search Profiles
 */
export const searchProfiles = async (
  params: SearchProfilesParams,
  options?: RequestInit,
): Promise<searchProfilesResponseSuccess> => {
  const res = await fetch(getSearchProfilesUrl(params), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeSearchProfilesResponse(parsedBody as SearchProfilesResponse);
  }
  const data = contentType.includes("json") ? SearchProfilesResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as searchProfilesResponseSuccess;
};

const deserializeSearchProfilesResponse = (
  data: SearchProfilesResponse,
): SearchProfilesResponse => {
  if (data == null) return data;
  if (data.profiles != null) {
    for (let i0 = 0; i0 < data.profiles.length; i0++) {
      const item0 = data.profiles[i0]!;
      item0.created_at = new Date(item0.created_at);
    }
  }
  return data;
};

export const getSearchProfilesQueryKey = (params?: SearchProfilesParams) => {
  return [`/api/v1/profiles/search`, ...(params ? [params] : [])] as const;
};

export const getSearchProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchProfiles>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: SearchProfilesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchProfilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchProfiles>>> = ({ signal }) =>
    searchProfiles(params, { signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchProfiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof searchProfiles>>>;
export type SearchProfilesQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useSearchProfiles<
  TData = Awaited<ReturnType<typeof searchProfiles>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: SearchProfilesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchProfiles>>,
          TError,
          Awaited<ReturnType<typeof searchProfiles>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchProfiles<
  TData = Awaited<ReturnType<typeof searchProfiles>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: SearchProfilesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchProfiles>>,
          TError,
          Awaited<ReturnType<typeof searchProfiles>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchProfiles<
  TData = Awaited<ReturnType<typeof searchProfiles>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: SearchProfilesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search Profiles
 */

export function useSearchProfiles<
  TData = Awaited<ReturnType<typeof searchProfiles>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: SearchProfilesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchProfilesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useSearchProfiles} query
 */
export const invalidateSearchProfiles = async (
  queryClient: QueryClient,
  params: SearchProfilesParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getSearchProfilesQueryKey(params) }, options);

  return queryClient;
};

export const getSearchProfilesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof searchProfiles>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: SearchProfilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchProfilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchProfiles>>> = ({ signal }) =>
    searchProfiles(params, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type SearchProfilesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchProfiles>>
>;
export type SearchProfilesSuspenseQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useSearchProfilesSuspense<
  TData = Awaited<ReturnType<typeof searchProfiles>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: SearchProfilesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchProfilesSuspense<
  TData = Awaited<ReturnType<typeof searchProfiles>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: SearchProfilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchProfilesSuspense<
  TData = Awaited<ReturnType<typeof searchProfiles>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: SearchProfilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search Profiles
 */

export function useSearchProfilesSuspense<
  TData = Awaited<ReturnType<typeof searchProfiles>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: SearchProfilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchProfiles>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchProfilesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getProfileResponse200 = {
  data: GetAccountResponseOutput;
  status: 200;
};

export type getProfileResponse404 = {
  data: ErrorDetailResponse;
  status: 404;
};

export type getProfileResponseSuccess = getProfileResponse200 & {
  headers: Headers;
};
export type getProfileResponseError = getProfileResponse404 & {
  headers: Headers;
};

export const getGetProfileUrl = (accountId: AccountIdOrMe) => {
  return `/api/v1/profiles/${accountId}`;
};

/**
 * Get profile information of an account. Profile information is public and can be accessed even if not
 * logged in, but the special value `@me` can only be used if currently authenticated.
 * @summary Get Profile
 */
export const getProfile = async (
  accountId: AccountIdOrMe,
  options?: RequestInit,
): Promise<getProfileResponseSuccess> => {
  const res = await fetch(getGetProfileUrl(accountId), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: getProfileResponseError["data"]; status?: number } =
      new globalThis.Error();
    const data: getProfileResponseError["data"] = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeGetProfileResponse(parsedBody as GetAccountResponse);
  }
  const data = contentType.includes("json") ? GetAccountResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as getProfileResponseSuccess;
};

const deserializeGetProfileResponse = (data: GetAccountResponse): GetAccountResponse => {
  if (data == null) return data;
  if (data.profile != null) {
    data.profile.created_at = new Date(data.profile.created_at);
  }
  return data;
};

export const getGetProfileQueryKey = (accountId: AccountIdOrMe) => {
  return [`/api/v1/profiles/${accountId}`] as const;
};

export const getGetProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfileQueryKey(accountId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) =>
    getProfile(accountId, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: accountId !== null && accountId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>;
export type GetProfileQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  accountId: AccountIdOrMe,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Profile
 */

export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProfileQueryOptions(accountId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useGetProfile} query
 */
export const invalidateGetProfile = async (
  queryClient: QueryClient,
  accountId: AccountIdOrMe,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetProfileQueryKey(accountId) }, options);

  return queryClient;
};

export const getGetProfileSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfileQueryKey(accountId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) =>
    getProfile(accountId, { signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type GetProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>;
export type GetProfileSuspenseQueryError = globalThis.Error & {
  info?: ErrorDetailResponse;
  status?: number;
};

export function useGetProfileSuspense<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  accountId: AccountIdOrMe,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfileSuspense<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfileSuspense<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Profile
 */

export function useGetProfileSuspense<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = globalThis.Error & { info?: ErrorDetailResponse; status?: number },
>(
  accountId: AccountIdOrMe,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProfileSuspenseQueryOptions(accountId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listSessionsResponse200 = {
  data: ListSessionsResponseOutput;
  status: 200;
};

export type listSessionsResponseSuccess = listSessionsResponse200 & {
  headers: Headers;
};

export const getListSessionsUrl = () => {
  return `/api/v1/sessions`;
};

/**
 * Lists all currently active sessions for the authorized account.
 * @summary List Sessions
 */
export const listSessions = async (options?: RequestInit): Promise<listSessionsResponseSuccess> => {
  const res = await fetch(getListSessionsUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  let parsedBody = body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  if (body && contentType.includes("json") && res.status === 200) {
    parsedBody = deserializeListSessionsResponse(parsedBody as ListSessionsResponse);
  }
  const data = contentType.includes("json") ? ListSessionsResponse.parse(parsedBody) : parsedBody;
  return { data, status: res.status, headers: res.headers } as listSessionsResponseSuccess;
};

const deserializeListSessionsResponse = (data: ListSessionsResponse): ListSessionsResponse => {
  if (data == null) return data;
  if (data.sessions != null) {
    for (let i0 = 0; i0 < data.sessions.length; i0++) {
      const item0 = data.sessions[i0]!;
      item0.created_at = new Date(item0.created_at);
      item0.expires_at = new Date(item0.expires_at);
    }
  }
  return data;
};

export const getListSessionsQueryKey = () => {
  return [`/api/v1/sessions`] as const;
};

export const getListSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSessionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessions>>> = ({ signal }) =>
    listSessions({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSessions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSessions>>>;
export type ListSessionsQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListSessions<
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSessions>>,
          TError,
          Awaited<ReturnType<typeof listSessions>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSessions<
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSessions>>,
          TError,
          Awaited<ReturnType<typeof listSessions>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSessions<
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Sessions
 */

export function useListSessions<
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSessionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidates the {@link useListSessions} query
 */
export const invalidateListSessions = async (
  queryClient: QueryClient,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListSessionsQueryKey() }, options);

  return queryClient;
};

export const getListSessionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSessionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessions>>> = ({ signal }) =>
    listSessions({ signal, ...fetchOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type ListSessionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSessions>>>;
export type ListSessionsSuspenseQueryError = globalThis.Error & { info?: unknown; status?: number };

export function useListSessionsSuspense<
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSessionsSuspense<
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSessionsSuspense<
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Sessions
 */

export function useListSessionsSuspense<
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSessionsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteSessionResponse204 = {
  data: void;
  status: 204;
};

export type deleteSessionResponseSuccess = deleteSessionResponse204 & {
  headers: Headers;
};

export const getDeleteSessionUrl = (sessionId: string) => {
  return `/api/v1/sessions/${sessionId}`;
};

/**
 * Delete a session, immediately removing access for any device using that session.
 * @summary Delete Session
 */
export const deleteSession = async (
  sessionId: string,
  options?: RequestInit,
): Promise<deleteSessionResponseSuccess> => {
  const res = await fetch(getDeleteSessionUrl(sessionId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } = new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteSessionResponseSuccess["data"] = body ? JSON.parse(body) : undefined;
  return { data, status: res.status, headers: res.headers } as deleteSessionResponseSuccess;
};

export const getDeleteSessionMutationKey = () => ["deleteSession"] as const;

export const getDeleteSessionMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  queryClient: QueryClient,
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSession>>,
      TError,
      DeleteSessionMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSession>>,
  TError,
  DeleteSessionMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteSessionMutationKey();
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSession>>,
    DeleteSessionMutationVariables
  > = (props) => {
    const { sessionId } = props ?? {};

    return deleteSession(sessionId, fetchOptions);
  };

  const onSuccess = (
    data: Awaited<ReturnType<typeof deleteSession>>,
    variables: DeleteSessionMutationVariables,
    onMutateResult: TContext,
    context: MutationFunctionContext,
  ) => {
    if (!options?.skipInvalidation) {
      queryClient.invalidateQueries({ queryKey: getListSessionsQueryKey() });
    }
    mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
  };

  return { ...mutationOptions, mutationFn, onSuccess };
};

export type DeleteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSession>>>;

export type DeleteSessionMutationError = globalThis.Error & { info?: unknown; status?: number };
export type DeleteSessionMutationVariables = { sessionId: string };

/**
 * @summary Delete Session
 */
export const useDeleteSession = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSession>>,
      TError,
      DeleteSessionMutationVariables,
      TContext
    >;
    skipInvalidation?: boolean;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSession>>,
  TError,
  DeleteSessionMutationVariables,
  TContext
> => {
  const backupQueryClient = useQueryClient();
  return useMutation(
    getDeleteSessionMutationOptions(queryClient ?? backupQueryClient, options),
    queryClient,
  );
};
